var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg401ErrorUnauthorizedAnimate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-401-error-unauthorized",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-401-error-unauthorized:not(.animated) .animable {opacity: 0;}svg#freepik_stories-401-error-unauthorized.animated #freepik--card-reader--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-401-error-unauthorized.animated #freepik--Character--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut,6s Infinite  linear shake;animation-delay: 0s,2s;}svg#freepik_stories-401-error-unauthorized.animated #freepik--id-card--inject-63 {animation: 1s 1 forwards ease-out slideDown;animation-delay: 1.0s;opacity: 0}svg#freepik_stories-401-error-unauthorized.animated #freepik--error-401--inject-63 {animation: 3s Infinite  linear heartbeat;animation-delay: 0.5s;}            @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes shake {                10%, 90% {                    transform: translate3d(-1px, 0, 0);                  }                  20%, 80% {                    transform: translate3d(2px, 0, 0);                  }                  30%, 50%, 70% {                    transform: translate3d(-4px, 0, 0);                  }                  40%, 60% {                    transform: translate3d(4px, 0, 0);                  }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63",
    className: "animable",
    style: {
      transformOrigin: "250px 344.33px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-63",
    cx: 250,
    cy: 344.33,
    rx: 237.96,
    ry: 135.52,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 344.33px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-63",
    className: "animable",
    style: {
      transformOrigin: "253.545px 367.999px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-63",
    cx: 391.46,
    cy: 369.93,
    rx: 64.02,
    ry: 36.96,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "391.46px 369.93px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M367.87,399.42,292.65,356a1,1,0,0,1,0-1.84l5.8-3.35a3.52,3.52,0,0,1,3.19,0l75.22,43.43a1,1,0,0,1,0,1.84l-5.81,3.35A3.5,3.5,0,0,1,367.87,399.42Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "334.755px 375.117px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M54.79,410.87,82.65,427A17,17,0,0,0,98,427l161.11-93c4.24-2.45,4.24-6.42,0-8.87L231.25,309a17,17,0,0,0-15.36,0L54.79,402C50.55,404.45,50.55,408.42,54.79,410.87Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "156.95px 367.999px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-63",
    className: "animable",
    style: {
      transformOrigin: "50.1512px 368.444px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-63",
    className: "animable",
    style: {
      transformOrigin: "50.1512px 368.444px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.55,399.89c.44-11.46.75-22.81-4.67-39.26-4.55-13.81-17.71-27.79-26.21-28.1-11.23-.41-12.56,7.57-6.78,15.86,4.28,6.13,18.34,14.19,24.82,29.14a66.84,66.84,0,0,1,5.23,26.76Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "50.1512px 368.402px"
    },
    id: "elqnbggtbgsbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,396.9a.49.49,0,0,1-.38-.48c.6-25.91-13.95-48.66-27.19-56.48a.5.5,0,1,1,.51-.87c13.08,7.14,27.76,30.11,27.69,57.33a.51.51,0,0,1-.49.52A.34.34,0,0,1,67.12,396.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "53.5255px 367.961px"
    },
    id: "ello8evhtzysd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.64,403.89a3.44,3.44,0,0,1-5-1.81,41.77,41.77,0,0,0-9.46-14.5c-7.31-7.33-17.42-12-19-16.91-1.94-6,3.36-9,11.94-6.92,10.31,2.47,21.88,14.87,23.21,39.16Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "47.555px 383.732px"
    },
    id: "elh0racxxnuyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrdsre9yzb69"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "47.555px 383.732px"
    },
    className: "animable",
    id: "elkkp1qb4igfq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.64,403.89a3.44,3.44,0,0,1-5-1.81,41.77,41.77,0,0,0-9.46-14.5c-7.31-7.33-17.42-12-19-16.91-1.94-6,3.36-9,11.94-6.92,10.31,2.47,21.88,14.87,23.21,39.16Z",
    id: "elg620d4s23vs",
    className: "animable",
    style: {
      transformOrigin: "47.555px 383.732px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M63.56,402.27a.5.5,0,0,1-.37-.41C59.75,380.58,44.4,370.23,37.52,368a.51.51,0,0,1-.33-.64.5.5,0,0,1,.64-.32C45.44,369.5,60.68,380,64.19,401.7a.51.51,0,0,1-.42.58A.72.72,0,0,1,63.56,402.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "50.6809px 384.648px"
    },
    id: "eliy5rrxsqr3",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--card-reader--inject-63",
    className: "animable",
    style: {
      transformOrigin: "161.257px 274.743px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--card-reader--inject-63",
    className: "animable",
    style: {
      transformOrigin: "161.257px 274.743px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.42,418.44c-4.17,2.41-9.93,2.07-16.3-1.61L69,408.65A8.48,8.48,0,0,1,65.12,402V219.57a2.69,2.69,0,0,1,1.11-2.48l151.26-87.33a2.69,2.69,0,0,1,2.72.26l14.16,8.18c12.72,7.35,23,25.21,23,39.9V316.21c0,7.35-2.59,12.52-6.77,14.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "161.237px 274.742px"
    },
    id: "elko4i6t381c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,171.06c-2.55-12.95-11.57-26.65-22.32-32.86L220.21,130a2.69,2.69,0,0,0-2.72-.26L66.23,217.09a2.69,2.69,0,0,0-1.11,2.48v20.51l36,20.79Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "160.897px 195.178px"
    },
    id: "el6oejg94p8q9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwynrn64a8vm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.71,157.3l-165,95.26L65.12,240.08V219.57a2.69,2.69,0,0,1,1.11-2.48l151.26-87.33a2.65,2.65,0,0,1,2.71.27l14.17,8.17C241.28,142.2,247.49,149.29,251.71,157.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "158.407px 191.034px"
    },
    className: "animable",
    id: "elq88tg9vpc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.41,316.21v-4.16L101.13,402.28l-36-20.8V402A8.48,8.48,0,0,0,69,408.65l14.16,8.18c6.37,3.68,12.13,4,16.3,1.61l151.22-87.31C254.82,328.73,257.41,323.56,257.41,316.21Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "161.27px 366.01px"
    },
    id: "ellibg46ad4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,262.43l57.38-33.13c1.06-.62,1.92-.12,1.92,1.1v45.47a4.25,4.25,0,0,1-1.91,3.33l-57.39,33.13c-1.06.61-1.92.11-1.92-1.11V265.75A4.24,4.24,0,0,1,117.45,262.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.14px 270.812px"
    },
    id: "ely7q6jvmho5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,273.41V230.33l-55.59,32.1a4.24,4.24,0,0,0-1.92,3.32v43.08l55.6-32.1A4.23,4.23,0,0,0,173,273.41Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "144.245px 269.58px"
    },
    id: "elp9n8813h5kb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.06,293.29a1.23,1.23,0,0,1-.15-.75V274.17a2.38,2.38,0,0,1,.15-.93,1.19,1.19,0,0,1,.49-.53l5.57-3.22c.18-.1.31-.07.38.09a2.25,2.25,0,0,1,.12.89v.76a3.46,3.46,0,0,1-.12,1,.83.83,0,0,1-.38.53l-3.68,2.12V280l3.28-1.89c.18-.1.31-.07.38.09a2.19,2.19,0,0,1,.12.88v.77a3.46,3.46,0,0,1-.12,1,.86.86,0,0,1-.38.53l-3.28,1.89v5.58l3.7-2.14c.17-.09.29-.07.36.09a2.21,2.21,0,0,1,.12.9v.76a3.48,3.48,0,0,1-.12,1,.83.83,0,0,1-.36.5l-5.59,3.22C121.33,293.39,121.16,293.4,121.06,293.29Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "124.264px 281.396px"
    },
    id: "elq59bgjbiglb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,287.83V269.16a2.23,2.23,0,0,1,.16-.92,1.18,1.18,0,0,1,.51-.55l3.07-1.77q3.83-2.22,3.83,3.36a10.07,10.07,0,0,1-1.79,6v.11c.51.14.94,1,1.29,2.45l1.15,5a1.36,1.36,0,0,0,0,.17,1.09,1.09,0,0,1,0,.18c0,.45-.34.87-1,1.27l-.56.31c-.6.35-.92.32-1-.1l-1.05-5a2,2,0,0,0-.52-1.07c-.2-.14-.5-.1-.91.14l-.7.4v7.25a1.69,1.69,0,0,1-1,1.44l-.52.3C129.91,288.49,129.58,288.39,129.58,287.83Zm3.87-13.07a2.38,2.38,0,0,0,.88-1.3,6.81,6.81,0,0,0,.36-2.32,3.42,3.42,0,0,0-.35-1.87c-.24-.3-.56-.33-1-.1l-1.29.75v5.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "133.691px 276.815px"
    },
    id: "eluqvuq7pxs1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,282.18V263.51a2.18,2.18,0,0,1,.16-.91A1.21,1.21,0,0,1,140,262l3.07-1.77c2.55-1.48,3.83-.35,3.83,3.36a10.07,10.07,0,0,1-1.79,6v.12c.51.13.94.95,1.29,2.45l1.15,5a1.36,1.36,0,0,0,0,.17,1.09,1.09,0,0,1,0,.18c0,.45-.34.87-1,1.27l-.56.32c-.59.34-.93.31-1-.1L144,274a2,2,0,0,0-.52-1.08c-.2-.14-.5-.09-.91.14l-.7.41v7.25a1.69,1.69,0,0,1-1,1.43l-.52.3C139.69,282.84,139.36,282.75,139.36,282.18Zm3.87-13.07a2.35,2.35,0,0,0,.88-1.29,6.91,6.91,0,0,0,.36-2.33,3.35,3.35,0,0,0-.35-1.86.66.66,0,0,0-1-.11l-1.3.75v5.64Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "143.456px 271.144px"
    },
    id: "el7sixbga167u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.76,267.24q0-10.44,4.92-13.29t4.9,7.63q0,10.5-4.9,13.33T148.76,267.24Zm6.67,1.71a22.8,22.8,0,0,0,.57-5.89,15.44,15.44,0,0,0-.56-5.21,1.08,1.08,0,0,0-1.74-.62,4.3,4.3,0,0,0-1.78,2.65,22.52,22.52,0,0,0-.57,5.87,15.59,15.59,0,0,0,.57,5.23c.39.88,1,1.1,1.78.63A4.22,4.22,0,0,0,155.43,269Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "153.67px 264.426px"
    },
    id: "el1yo1o7lowa6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.56,269.94V251.27a2.18,2.18,0,0,1,.16-.91,1.21,1.21,0,0,1,.51-.56L164.3,248c2.55-1.48,3.83-.35,3.83,3.36a10.07,10.07,0,0,1-1.79,6v.12c.51.13.94.95,1.29,2.45l1.15,5a1.36,1.36,0,0,0,0,.17,1.1,1.1,0,0,1,0,.18c0,.45-.35.87-1,1.27l-.56.32c-.59.34-.92.31-1-.1l-1-5a2,2,0,0,0-.52-1.08c-.2-.14-.5-.1-.91.14l-.7.41v7.25a1.68,1.68,0,0,1-1,1.43l-.52.3C160.89,270.6,160.56,270.51,160.56,269.94Zm3.87-13.07a2.35,2.35,0,0,0,.88-1.29,6.91,6.91,0,0,0,.36-2.33,3.35,3.35,0,0,0-.35-1.86.66.66,0,0,0-1-.11l-1.3.75v5.64Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "164.671px 258.91px"
    },
    id: "elceo6l8gad6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,316.22a.79.79,0,0,0-.77.08L117,322a2.43,2.43,0,0,0-1.09,1.89v7.35a.76.76,0,0,0,.32.71c.19.12,1.7,1,1.89,1.09a.75.75,0,0,0,.78-.07l9.79-5.65a2.43,2.43,0,0,0,1.09-1.89V318a.76.76,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.845px 324.636px"
    },
    id: "elaf8eiiek3n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.22,331.9c.19.12,1.7,1,1.89,1.09a.75.75,0,0,0,.78-.07l7.46-4.31-10.13-5.84a2.2,2.2,0,0,0-.32,1.07v7.35A.76.76,0,0,0,116.22,331.9Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.123px 327.919px"
    },
    id: "elf9gj9byqchh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,324.94v7.35c0,.7.49,1,1.09.63l9.79-5.65a2.43,2.43,0,0,0,1.09-1.89V318c0-.7-.49-1-1.09-.63L118.89,323A2.43,2.43,0,0,0,117.8,324.94Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.785px 325.145px"
    },
    id: "elr1h6xuh104c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.52,324.54a.35.35,0,0,1,0-.16.64.64,0,0,1,.06-.18l1.18-2.07.11-.18a.41.41,0,0,1,.14-.15l.67-.39s.08,0,.1,0a.18.18,0,0,1,0,.14V327a.41.41,0,0,1,0,.18.23.23,0,0,1-.1.13l-.72.41a.07.07,0,0,1-.1,0s0-.07,0-.13V323.9l-.66,1.13c0,.06-.06.1-.1.11s-.08,0-.1,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "123.652px 324.576px"
    },
    id: "elx9vhm8m1xsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,306.87a.77.77,0,0,0-.78.07l-9.78,5.65a2.42,2.42,0,0,0-1.1,1.9v7.35a.76.76,0,0,0,.32.7l1.9,1.1a.76.76,0,0,0,.78-.08l9.78-5.64A2.42,2.42,0,0,0,146,316v-7.35a.78.78,0,0,0-.33-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.05px 315.254px"
    },
    id: "elut9v1tvc2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,322.54l1.9,1.1a.76.76,0,0,0,.78-.08l7.45-4.3-10.13-5.85a2.32,2.32,0,0,0-.32,1.08v7.35A.76.76,0,0,0,132.42,322.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.323px 318.561px"
    },
    id: "eljgumegjaxc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,315.58v7.35c0,.7.49,1,1.1.63l9.78-5.64A2.42,2.42,0,0,0,146,316v-7.35c0-.7-.49-1-1.1-.63l-9.78,5.65A2.41,2.41,0,0,0,134,315.58Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "140px 315.79px"
    },
    id: "ele0t4qeunjzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,313.59a4,4,0,0,1,0,.49,3.34,3.34,0,0,1-.11.51,5.4,5.4,0,0,1-.21.54c-.09.19-.19.39-.31.61l-.77,1.33,1.37-.79a.09.09,0,0,1,.11,0s0,.07,0,.13v.89a.43.43,0,0,1,0,.19.36.36,0,0,1-.11.13l-2.89,1.66a.08.08,0,0,1-.1,0,.2.2,0,0,1,0-.14v-.72a1.5,1.5,0,0,1,0-.29,1.34,1.34,0,0,1,.12-.3l1.64-2.75a2,2,0,0,0,.24-.54,1.81,1.81,0,0,0,.05-.38.86.86,0,0,0,0-.15.36.36,0,0,0-.07-.18.24.24,0,0,0-.14-.1.37.37,0,0,0-.24.07.88.88,0,0,0-.25.22,1.82,1.82,0,0,0-.15.27,1.17,1.17,0,0,0-.07.25l0,.18a.52.52,0,0,1-.08.2.49.49,0,0,1-.14.11l-.67.39a.06.06,0,0,1-.08,0,.14.14,0,0,1,0-.11,3.53,3.53,0,0,1,.1-.76,3.46,3.46,0,0,1,.28-.8,3.57,3.57,0,0,1,.47-.74,2.73,2.73,0,0,1,.66-.56,1.45,1.45,0,0,1,.64-.2.65.65,0,0,1,.46.17,1,1,0,0,1,.29.47A2.4,2.4,0,0,1,141.48,313.59Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "140.009px 315.774px"
    },
    id: "el7dj3pg47vv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,297.51a.76.76,0,0,0-.77.08l-9.79,5.65a2.41,2.41,0,0,0-1.09,1.89v7.35a.77.77,0,0,0,.32.71l1.89,1.09a.77.77,0,0,0,.78-.07l9.79-5.65a2.43,2.43,0,0,0,1.09-1.9v-7.35a.75.75,0,0,0-.32-.7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "155.285px 305.898px"
    },
    id: "elbvv0tiz9lpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,313.19l1.89,1.09a.77.77,0,0,0,.78-.07l7.46-4.31-10.13-5.85a2.24,2.24,0,0,0-.32,1.08v7.35A.77.77,0,0,0,148.63,313.19Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.533px 309.202px"
    },
    id: "ely8qrngauymn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,306.23v7.35c0,.69.49,1,1.09.63l9.79-5.65a2.43,2.43,0,0,0,1.09-1.9v-7.35c0-.69-.49-1-1.09-.63l-9.79,5.65A2.43,2.43,0,0,0,150.21,306.23Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "156.195px 306.445px"
    },
    id: "elcqbmxx3nq2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.46,302.47a.08.08,0,0,1,.11,0s0,.07,0,.13v.89a.43.43,0,0,1,0,.19,1.47,1.47,0,0,1-.07.17l-.66,1.41a.77.77,0,0,1,.69.17,1.18,1.18,0,0,1,.27.9,3.33,3.33,0,0,1-.42,1.68,3.37,3.37,0,0,1-1.2,1.17,1.8,1.8,0,0,1-.69.26.81.81,0,0,1-.51-.09.69.69,0,0,1-.32-.35,1.13,1.13,0,0,1-.12-.54.4.4,0,0,1,0-.15.22.22,0,0,1,.09-.1l.69-.4a.14.14,0,0,1,.17,0l.14.09a.27.27,0,0,0,.19.06.6.6,0,0,0,.33-.11,1.38,1.38,0,0,0,.44-.39.87.87,0,0,0,.17-.52c0-.2-.06-.31-.17-.34a.7.7,0,0,0-.44.12l-.45.26a.08.08,0,0,1-.1,0,.2.2,0,0,1,0-.14v-.72a.65.65,0,0,1,0-.19,1.59,1.59,0,0,1,.08-.18l.58-1.24-1.43.82s-.08,0-.1,0a.18.18,0,0,1-.05-.14v-.89a.41.41,0,0,1,.05-.18.2.2,0,0,1,.1-.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "156.171px 305.949px"
    },
    id: "elnbm8wivnoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,288.15a.79.79,0,0,0-.77.08l-9.79,5.65a2.43,2.43,0,0,0-1.09,1.9v7.34a.78.78,0,0,0,.31.71l1.9,1.1a.78.78,0,0,0,.78-.08l9.78-5.65a2.4,2.4,0,0,0,1.1-1.89V290a.78.78,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "171.455px 296.542px"
    },
    id: "elpc1z8hcct2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,303.83l1.9,1.09a.75.75,0,0,0,.78-.07l7.46-4.3-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.34A.78.78,0,0,0,164.83,303.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.743px 299.849px"
    },
    id: "elhwmvd961df4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,296.87v7.35c0,.7.49,1,1.1.63l9.78-5.65a2.4,2.4,0,0,0,1.1-1.89V290c0-.7-.49-1-1.1-.63L167.51,295A2.38,2.38,0,0,0,166.41,296.87Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "172.4px 297.11px"
    },
    id: "elysz45o08wch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37,293.86a.08.08,0,0,1,.1,0,.18.18,0,0,1,.05.14v.89a.41.41,0,0,1-.05.18.24.24,0,0,1-.1.13l-1.64,1v1.15l1.53-.88a.07.07,0,0,1,.1,0,.16.16,0,0,1,0,.13v.89a.45.45,0,0,1,0,.19.34.34,0,0,1-.1.13l-1.53.88v1.82a.39.39,0,0,1,0,.18.29.29,0,0,1-.11.13l-.71.41a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-5.44a.46.46,0,0,1,0-.19.26.26,0,0,1,.11-.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "171.154px 297.546px"
    },
    id: "elexu9ydd2p4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.83,295.49a.17.17,0,0,1,0-.15.6.6,0,0,1,.06-.19l1.18-2.06a1.8,1.8,0,0,1,.1-.18.36.36,0,0,1,.15-.15l.67-.39a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13V298a.43.43,0,0,1,0,.19.49.49,0,0,1-.1.13l-.72.41a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-3.68l-.65,1.13a.23.23,0,0,1-.11.11.1.1,0,0,1-.1,0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "173.958px 295.551px"
    },
    id: "eloesqloa2fih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,332.54a.76.76,0,0,0-.77.07L117,338.26a2.43,2.43,0,0,0-1.09,1.9v7.35a.77.77,0,0,0,.32.71c.19.11,1.7,1,1.89,1.09a.76.76,0,0,0,.78-.08l9.79-5.64a2.43,2.43,0,0,0,1.09-1.9v-7.35a.77.77,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.845px 340.924px"
    },
    id: "elckpv9x8evjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.22,348.22c.19.11,1.7,1,1.89,1.09a.76.76,0,0,0,.78-.08l7.46-4.3-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.35A.77.77,0,0,0,116.22,348.22Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.123px 344.231px"
    },
    id: "elx34eq03rl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,341.25v7.35c0,.7.49,1,1.09.63l9.79-5.64a2.43,2.43,0,0,0,1.09-1.9v-7.35c0-.7-.49-1-1.09-.63l-9.79,5.65A2.43,2.43,0,0,0,117.8,341.25Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.785px 341.47px"
    },
    id: "els87rbrnf8ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05,344a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13V343l-1.72,1a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-.89a1,1,0,0,1,.07-.4l1.64-4.12a.59.59,0,0,1,.09-.18.35.35,0,0,1,.11-.09l.82-.48s.08,0,.11,0a.17.17,0,0,1,0,.13V341l.47-.27a.08.08,0,0,1,.11,0,.2.2,0,0,1,0,.14v.89a.39.39,0,0,1,0,.18.25.25,0,0,1-.11.13l-.47.27v.86a.41.41,0,0,1,0,.19.28.28,0,0,1-.11.13Zm-.12-2.36v-1.55l-.8,2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "123.82px 340.859px"
    },
    id: "eldfhbtd21ofl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,323.18a.78.78,0,0,0-.78.08l-9.78,5.65a2.4,2.4,0,0,0-1.1,1.89v7.35a.79.79,0,0,0,.32.71l1.9,1.09a.77.77,0,0,0,.78-.07l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9V325a.76.76,0,0,0-.33-.7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.04px 331.568px"
    },
    id: "elhb8juesxwxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,338.86l1.9,1.09a.77.77,0,0,0,.78-.07l7.45-4.31-10.13-5.85a2.35,2.35,0,0,0-.32,1.08v7.35A.79.79,0,0,0,132.42,338.86Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.323px 334.872px"
    },
    id: "elm4m8jhxma4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,331.9v7.35c0,.69.49,1,1.1.63l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9V325c0-.69-.49-1-1.1-.63L135.1,330A2.42,2.42,0,0,0,134,331.9Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "139.99px 332.125px"
    },
    id: "elwu9mysr03u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,333.35l.09.11a.31.31,0,0,0,.11.09.27.27,0,0,0,.16,0,.66.66,0,0,0,.22-.08.87.87,0,0,0,.22-.17,1.14,1.14,0,0,0,.18-.25,1,1,0,0,0,.13-.3,1.29,1.29,0,0,0,.05-.35.41.41,0,0,0-.15-.38c-.09-.07-.23-.05-.39.05a.72.72,0,0,0-.15.11,1.58,1.58,0,0,0-.12.15l-.11.13a.29.29,0,0,1-.08.08l-.86.49a.08.08,0,0,1-.11,0,.15.15,0,0,1,0-.14l.16-3.1a.49.49,0,0,1,.05-.19.2.2,0,0,1,.1-.12l2.34-1.35a.08.08,0,0,1,.1,0,.2.2,0,0,1,.05.14v.89a.45.45,0,0,1-.05.19.25.25,0,0,1-.1.12l-1.59.92,0,.78a1.79,1.79,0,0,1,.51-.49,1.56,1.56,0,0,1,.59-.21.75.75,0,0,1,.47.12.94.94,0,0,1,.31.44,2.5,2.5,0,0,1,.11.79,3.77,3.77,0,0,1-.12,1,4.31,4.31,0,0,1-.34.85,3.25,3.25,0,0,1-.51.69,2.9,2.9,0,0,1-.62.5,1.57,1.57,0,0,1-.67.23.72.72,0,0,1-.49-.11.73.73,0,0,1-.31-.39,1.56,1.56,0,0,1-.12-.6.28.28,0,0,1,0-.15.24.24,0,0,1,.08-.11l.7-.4a.13.13,0,0,1,.13,0A.15.15,0,0,1,139.4,333.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "140.045px 331.604px"
    },
    id: "elz3o9ux7vt0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,313.82a.79.79,0,0,0-.77.08l-9.79,5.65a2.43,2.43,0,0,0-1.09,1.9v7.35a.75.75,0,0,0,.32.7l1.89,1.1a.78.78,0,0,0,.78-.08l9.79-5.65a2.41,2.41,0,0,0,1.09-1.89v-7.35a.76.76,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "155.285px 322.212px"
    },
    id: "el4ck7gmigt3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,329.5l1.89,1.1a.78.78,0,0,0,.78-.08l7.46-4.3-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.35A.75.75,0,0,0,148.63,329.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.533px 325.52px"
    },
    id: "eln1hbxhj8wkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,322.54v7.35c0,.7.49,1,1.09.63l9.79-5.65a2.41,2.41,0,0,0,1.09-1.89v-7.35c0-.7-.49-1-1.09-.63l-9.79,5.65A2.4,2.4,0,0,0,150.21,322.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "156.195px 322.76px"
    },
    id: "elur9o08qm7mp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.84,322.43a3.42,3.42,0,0,1-.13,1,3.68,3.68,0,0,1-.35.87,4.27,4.27,0,0,1-.52.72,2.61,2.61,0,0,1-.63.5,1.45,1.45,0,0,1-.62.22.89.89,0,0,1-.52-.12.93.93,0,0,1-.36-.45,2.1,2.1,0,0,1-.13-.82,2.74,2.74,0,0,1,0-.5c0-.15.06-.31.1-.45s.08-.29.13-.43.09-.26.14-.38l1-2.77.06-.14a.28.28,0,0,1,.11-.13l.87-.5s.06,0,.08,0a.16.16,0,0,1,0,.11.15.15,0,0,1,0,.07.43.43,0,0,1,0,.05l-.72,1.9a1.26,1.26,0,0,1,.55-.1.75.75,0,0,1,.44.17,1.07,1.07,0,0,1,.31.46A2.31,2.31,0,0,1,157.84,322.43Zm-2.25,1.3a.67.67,0,0,0,.06.3.29.29,0,0,0,.14.15.27.27,0,0,0,.2,0,.65.65,0,0,0,.22-.08,1,1,0,0,0,.23-.19,1.06,1.06,0,0,0,.2-.26,1.34,1.34,0,0,0,.14-.32,1.36,1.36,0,0,0,.05-.36.76.76,0,0,0-.05-.29.32.32,0,0,0-.14-.16.33.33,0,0,0-.2,0,.79.79,0,0,0-.23.08,1.74,1.74,0,0,0-.22.18,1.35,1.35,0,0,0-.2.27,1.15,1.15,0,0,0-.14.32A1.13,1.13,0,0,0,155.59,323.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "156.205px 322.396px"
    },
    id: "ell9tht0e5gdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,348.82a.76.76,0,0,0-.77.07L117,354.54a2.43,2.43,0,0,0-1.09,1.9v7.35a.75.75,0,0,0,.32.7l1.89,1.1a.78.78,0,0,0,.78-.08l9.79-5.65a2.41,2.41,0,0,0,1.09-1.89v-7.35a.76.76,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.845px 357.203px"
    },
    id: "elmwaka2u85zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.22,364.49l1.89,1.1a.78.78,0,0,0,.78-.08l7.46-4.3-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.35A.75.75,0,0,0,116.22,364.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.123px 360.51px"
    },
    id: "elh1xzh9dmh3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,357.53v7.35c0,.7.49,1,1.09.63l9.79-5.65a2.41,2.41,0,0,0,1.09-1.89v-7.35c0-.7-.49-1-1.09-.63l-9.79,5.65A2.4,2.4,0,0,0,117.8,357.53Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.785px 357.75px"
    },
    id: "el6jldd5l1gda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.91,360.7a.89.89,0,0,1,0-.11l1.18-4.93-1.63.95a.09.09,0,0,1-.11,0,.23.23,0,0,1,0-.14v-.89a.58.58,0,0,1,0-.18.25.25,0,0,1,.11-.13l2.61-1.51a.09.09,0,0,1,.11,0s0,.07,0,.13v.78a2.28,2.28,0,0,1-.09.48L124,360.09l-.06.17a.34.34,0,0,1-.1.13l-.77.44a.06.06,0,0,1-.09,0S122.91,360.76,122.91,360.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "123.76px 357.296px"
    },
    id: "elscgfjxua9po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,339.46a.76.76,0,0,0-.78.08l-9.78,5.64a2.42,2.42,0,0,0-1.1,1.9v7.35a.79.79,0,0,0,.32.71l1.9,1.09a.77.77,0,0,0,.78-.07l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35a.78.78,0,0,0-.33-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.04px 347.846px"
    },
    id: "ele4ikm4sepir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,355.14l1.9,1.09a.77.77,0,0,0,.78-.07l7.45-4.31L132.42,346a2.32,2.32,0,0,0-.32,1.08v7.35A.79.79,0,0,0,132.42,355.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.323px 351.152px"
    },
    id: "el31hlzjo63g3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,348.17v7.35c0,.7.49,1,1.1.64l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35c0-.7-.49-1-1.1-.63l-9.78,5.65A2.41,2.41,0,0,0,134,348.17Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "139.99px 348.392px"
    },
    id: "elny18fj9w6zl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.45,347.8a2.91,2.91,0,0,1,.12-.82,4.18,4.18,0,0,1,.34-.78,3.53,3.53,0,0,1,.49-.66,2.39,2.39,0,0,1,.59-.48,1.48,1.48,0,0,1,.59-.2.79.79,0,0,1,.49.09.88.88,0,0,1,.33.4,1.5,1.5,0,0,1,.13.68,2.91,2.91,0,0,1-.08.66,3,3,0,0,1-.22.64.92.92,0,0,1,.28.38,1.89,1.89,0,0,1,.1.63,2.66,2.66,0,0,1-.13.83,3.54,3.54,0,0,1-.86,1.46,2.72,2.72,0,0,1-.63.5,1.66,1.66,0,0,1-.64.23.86.86,0,0,1-.51-.08.77.77,0,0,1-.34-.39,1.53,1.53,0,0,1-.13-.68,2.64,2.64,0,0,1,.1-.74,2.82,2.82,0,0,1,.27-.7,1,1,0,0,1-.21-.39A1.93,1.93,0,0,1,138.45,347.8Zm.93,1.84a.34.34,0,0,0,.15.33c.1,0,.25,0,.46-.11a1.15,1.15,0,0,0,.45-.42.92.92,0,0,0,.16-.5.31.31,0,0,0-.16-.32c-.09-.05-.25,0-.45.1a1.2,1.2,0,0,0-.46.43A1,1,0,0,0,139.38,349.64Zm.08-2.44a.35.35,0,0,0,.14.33c.1.06.22,0,.39-.06a1.09,1.09,0,0,0,.39-.38,1,1,0,0,0,.13-.49c0-.16,0-.28-.13-.33s-.23,0-.39.06a1,1,0,0,0-.39.38A1,1,0,0,0,139.46,347.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "139.989px 348.111px"
    },
    id: "elk9qmx2u4r2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,330.1a.76.76,0,0,0-.77.08l-9.79,5.65a2.43,2.43,0,0,0-1.09,1.89v7.35a.77.77,0,0,0,.32.71l1.89,1.09a.75.75,0,0,0,.78-.07l9.79-5.65a2.43,2.43,0,0,0,1.09-1.89v-7.35a.76.76,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "155.285px 338.489px"
    },
    id: "eldn0gsqpjr1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,345.78l1.89,1.09a.75.75,0,0,0,.78-.07l7.46-4.31-10.13-5.85a2.24,2.24,0,0,0-.32,1.08v7.35A.77.77,0,0,0,148.63,345.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.533px 341.794px"
    },
    id: "el0wemynb08fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,338.82v7.35c0,.7.49,1,1.09.63l9.79-5.65a2.43,2.43,0,0,0,1.09-1.89v-7.35c0-.7-.49-1-1.09-.64l-9.79,5.65A2.43,2.43,0,0,0,150.21,338.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "156.195px 339.038px"
    },
    id: "elsnocyskp0x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,338.74a3.43,3.43,0,0,1,.14-1,4.19,4.19,0,0,1,.36-.87,3.79,3.79,0,0,1,.51-.71,2.44,2.44,0,0,1,.6-.49,1.43,1.43,0,0,1,.59-.2.82.82,0,0,1,.52.12.93.93,0,0,1,.36.45,2.06,2.06,0,0,1,.13.8,2.35,2.35,0,0,1,0,.47,3.26,3.26,0,0,1-.09.45c0,.14-.08.28-.13.42s-.09.27-.14.39l-1,2.82a1,1,0,0,0-.06.14.28.28,0,0,1-.11.13l-.87.5a.06.06,0,0,1-.08,0,.18.18,0,0,1,0-.11.19.19,0,0,1,0-.08l0-.05.7-1.92a1.17,1.17,0,0,1-.51.07.69.69,0,0,1-.43-.18,1,1,0,0,1-.3-.45A2.16,2.16,0,0,1,154.58,338.74Zm2.2-1.27a.74.74,0,0,0-.05-.28.35.35,0,0,0-.13-.16.31.31,0,0,0-.19,0,.47.47,0,0,0-.22.07.73.73,0,0,0-.22.18,1.15,1.15,0,0,0-.19.26,1.13,1.13,0,0,0-.13.32,1,1,0,0,0-.05.33.59.59,0,0,0,.05.28.3.3,0,0,0,.13.16.28.28,0,0,0,.19,0,.51.51,0,0,0,.22-.07,1.16,1.16,0,0,0,.22-.18,2.48,2.48,0,0,0,.19-.26,1.53,1.53,0,0,0,.13-.32A1.26,1.26,0,0,0,156.78,337.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "156.191px 338.82px"
    },
    id: "el8jl7778ipxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,304.47a.74.74,0,0,0-.77.08l-9.79,5.64a2.43,2.43,0,0,0-1.09,1.9v7.35a.79.79,0,0,0,.31.71l1.9,1.09a.77.77,0,0,0,.78-.07l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35a.79.79,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "171.455px 312.856px"
    },
    id: "elqb8m2dg2i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,320.15l1.9,1.09a.77.77,0,0,0,.78-.07l7.46-4.31L164.84,311a2.21,2.21,0,0,0-.32,1.08v7.35A.79.79,0,0,0,164.83,320.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.742px 316.157px"
    },
    id: "elmzdcmbpo92k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,313.18v7.35c0,.7.49,1,1.1.64l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35c0-.7-.49-1-1.1-.63l-9.78,5.65A2.41,2.41,0,0,0,166.41,313.18Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "172.4px 313.402px"
    },
    id: "el87r3c47ymci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.92,310.43a.09.09,0,0,1,.11,0,.2.2,0,0,1,0,.14v.89a.39.39,0,0,1,0,.18.25.25,0,0,1-.11.13l-1.63,1v1.15l1.52-.88a.09.09,0,0,1,.11,0,.17.17,0,0,1,0,.13V314a.41.41,0,0,1,0,.19.36.36,0,0,1-.11.13l-1.52.88v1.82a.41.41,0,0,1,0,.18.28.28,0,0,1-.1.13l-.72.41a.08.08,0,0,1-.1,0,.2.2,0,0,1,0-.14v-5.44a.41.41,0,0,1,0-.18.24.24,0,0,1,.1-.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "170.7px 314.084px"
    },
    id: "eln5wgdvz10mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.58,310.22a4.15,4.15,0,0,1,0,.49,3.22,3.22,0,0,1-.11.5c-.06.18-.13.36-.21.55a6,6,0,0,1-.32.6l-.76,1.34,1.37-.79s.08,0,.1,0a.2.2,0,0,1,0,.14v.89a.49.49,0,0,1,0,.19.2.2,0,0,1-.1.12l-2.89,1.67a.08.08,0,0,1-.1,0,.17.17,0,0,1-.05-.13v-.73a1.67,1.67,0,0,1,0-.29,1.25,1.25,0,0,1,.12-.3l1.64-2.74a2,2,0,0,0,.24-.54,1.89,1.89,0,0,0,0-.38s0-.09,0-.15a.36.36,0,0,0-.07-.18.24.24,0,0,0-.14-.1.35.35,0,0,0-.24.06.79.79,0,0,0-.25.23,2.43,2.43,0,0,0-.15.26,1.61,1.61,0,0,0-.07.25l0,.18a.71.71,0,0,1-.08.21l-.14.11-.67.39a.06.06,0,0,1-.09,0,.16.16,0,0,1,0-.11,3.61,3.61,0,0,1,.1-.76,3.81,3.81,0,0,1,.75-1.53,2.52,2.52,0,0,1,.66-.56,1.2,1.2,0,0,1,.64-.2.65.65,0,0,1,.46.17,1,1,0,0,1,.29.47A2.4,2.4,0,0,1,175.58,310.22Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.083px 312.424px"
    },
    id: "elif484aw5y6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,320.77a.76.76,0,0,0-.77.07l-9.79,5.65a2.43,2.43,0,0,0-1.09,1.9v7.35a.77.77,0,0,0,.31.7l1.9,1.1a.78.78,0,0,0,.78-.08l9.78-5.65a2.38,2.38,0,0,0,1.1-1.89v-7.35a.79.79,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "171.455px 329.153px"
    },
    id: "el55zq9tlcyqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,336.44l1.9,1.1a.78.78,0,0,0,.78-.08l7.46-4.3-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.35A.77.77,0,0,0,164.83,336.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.743px 332.46px"
    },
    id: "elo6qtlq5zyhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,329.48v7.35c0,.7.49,1,1.1.63l9.78-5.65a2.38,2.38,0,0,0,1.1-1.89v-7.35c0-.7-.49-1-1.1-.63l-9.78,5.65A2.4,2.4,0,0,0,166.41,329.48Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "172.4px 329.7px"
    },
    id: "elri1yumy2lr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,326.75a.08.08,0,0,1,.11,0s0,.07,0,.13v.89a.43.43,0,0,1,0,.19.22.22,0,0,1-.11.12l-1.63,1v1.15l1.53-.88a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.9a.39.39,0,0,1,0,.18.36.36,0,0,1-.1.13l-1.53.88v1.82a.72.72,0,0,1,0,.19.26.26,0,0,1-.11.12l-.71.42c-.05,0-.08,0-.11,0a.17.17,0,0,1,0-.13V328.5a.39.39,0,0,1,0-.18.24.24,0,0,1,.11-.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "170.664px 330.424px"
    },
    id: "elc3arqjieacu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,324.75a.08.08,0,0,1,.1,0s0,.07,0,.13v.89a.58.58,0,0,1,0,.19l-.07.17-.67,1.41a.79.79,0,0,1,.7.17,1.18,1.18,0,0,1,.27.9,3.17,3.17,0,0,1-1.62,2.85,1.9,1.9,0,0,1-.7.26.84.84,0,0,1-.51-.09.69.69,0,0,1-.32-.35,1.13,1.13,0,0,1-.12-.54.28.28,0,0,1,0-.15.21.21,0,0,1,.08-.1l.69-.4c.08-.05.14-.05.17,0l.14.09a.29.29,0,0,0,.19.06.65.65,0,0,0,.34-.11,1.34,1.34,0,0,0,.43-.39.81.81,0,0,0,.17-.52c0-.2-.05-.31-.17-.33a.6.6,0,0,0-.43.11l-.46.26s-.07,0-.1,0a.2.2,0,0,1,0-.14v-.72a.63.63,0,0,1,0-.19,1.59,1.59,0,0,1,.08-.18l.58-1.24-1.43.83a.08.08,0,0,1-.1,0,.18.18,0,0,1,0-.14v-.89a.41.41,0,0,1,0-.18.24.24,0,0,1,.1-.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.054px 328.23px"
    },
    id: "el49y14rq6thv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,365.15a.76.76,0,0,0-.77.08L117,370.88a2.4,2.4,0,0,0-1.09,1.89v7.35a.77.77,0,0,0,.32.71c.19.11,1.7,1,1.89,1.09a.77.77,0,0,0,.78-.07l9.79-5.65a2.43,2.43,0,0,0,1.09-1.9V367a.77.77,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.845px 373.538px"
    },
    id: "elrft7thbo1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.22,380.83c.19.11,1.7,1,1.89,1.09a.77.77,0,0,0,.78-.07l7.46-4.31-10.13-5.85a2.21,2.21,0,0,0-.32,1.08v7.35A.77.77,0,0,0,116.22,380.83Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "121.123px 376.842px"
    },
    id: "elkusm45hkfzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,373.87v7.34c0,.7.49,1,1.09.64l9.79-5.65a2.43,2.43,0,0,0,1.09-1.9V367c0-.69-.49-1-1.09-.63L118.89,372A2.43,2.43,0,0,0,117.8,373.87Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "123.785px 374.108px"
    },
    id: "elqdllfwxhsij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.05,373.59l.38-.61h0s0,0,0,0h0s.06-.05.09,0,0,0,.07.07l.17.7a.34.34,0,0,1,0,.14.46.46,0,0,1-.07.14h0s0,0,0,0l-.45.31.36.23,0,0h0a.23.23,0,0,1,0,.13.33.33,0,0,1,0,.15l-.44.75a.16.16,0,0,1-.09.08.07.07,0,0,1-.08,0l0-.05-.17-.56-.16.75,0,.07a.44.44,0,0,1-.08.11.09.09,0,0,1-.09,0l-.44-.24a.1.1,0,0,1,0-.1.39.39,0,0,1,0-.15h0v-.06l.36-.64-.46.22h0s0,0-.07-.06a.19.19,0,0,1,0-.13l.17-.9a.35.35,0,0,1,.06-.14c0-.05.06-.07.09-.07h0l.39.16-.13-.6v-.07a.27.27,0,0,1,0-.14.2.2,0,0,1,.08-.11l.55-.32a.06.06,0,0,1,.08,0,.18.18,0,0,1,0,.11.2.2,0,0,1,0,.07Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "123.818px 374.323px"
    },
    id: "elng040dsmho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,355.79a.81.81,0,0,0-.78.08l-9.78,5.65a2.41,2.41,0,0,0-1.1,1.89v7.35a.78.78,0,0,0,.32.71l1.9,1.09a.75.75,0,0,0,.78-.07l9.78-5.65A2.41,2.41,0,0,0,146,365V357.6a.77.77,0,0,0-.33-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.05px 364.181px"
    },
    id: "elfmb4mrnp1oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,371.47l1.9,1.09a.75.75,0,0,0,.78-.07l7.45-4.31-10.13-5.84a2.28,2.28,0,0,0-.32,1.07v7.35A.78.78,0,0,0,132.42,371.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "137.323px 367.489px"
    },
    id: "eljtdlf2dic9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,364.51v7.35c0,.7.49,1,1.1.63l9.78-5.65A2.41,2.41,0,0,0,146,365V357.6c0-.7-.49-1-1.1-.64l-9.78,5.65A2.42,2.42,0,0,0,134,364.51Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "140px 364.728px"
    },
    id: "elp0eumf1crw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,361.4a1.3,1.3,0,0,1,.7-.22.71.71,0,0,1,.49.21,1.19,1.19,0,0,1,.29.56,3.29,3.29,0,0,1,.12.81c0,.24,0,.49,0,.75s0,.51,0,.75a4.94,4.94,0,0,1-.12.93,3.79,3.79,0,0,1-.29.9,3.53,3.53,0,0,1-.49.78,2.5,2.5,0,0,1-.7.59,1.31,1.31,0,0,1-.71.22.73.73,0,0,1-.49-.21,1.29,1.29,0,0,1-.29-.56,3.87,3.87,0,0,1-.11-.81c0-.22,0-.47,0-.73s0-.52,0-.77a5.9,5.9,0,0,1,.11-.93,4.31,4.31,0,0,1,.29-.9,3.94,3.94,0,0,1,.49-.78A2.69,2.69,0,0,1,140,361.4Zm.58,3.4c0-.49,0-1,0-1.42a2,2,0,0,0,0-.36.66.66,0,0,0-.09-.25.29.29,0,0,0-.18-.11.5.5,0,0,0-.27.09,1.06,1.06,0,0,0-.45.54,1.89,1.89,0,0,0-.1.36c0,.13,0,.27,0,.41,0,.48,0,.95,0,1.42a3.29,3.29,0,0,0,0,.36.52.52,0,0,0,.1.25.25.25,0,0,0,.18.11.43.43,0,0,0,.27-.09.87.87,0,0,0,.27-.23,1.33,1.33,0,0,0,.18-.31,1.36,1.36,0,0,0,.1-.36A2.73,2.73,0,0,0,140.57,364.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "140px 364.43px"
    },
    id: "elvppkucon4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,346.44a.76.76,0,0,0-.77.07l-9.79,5.65a2.43,2.43,0,0,0-1.09,1.9v7.35a.75.75,0,0,0,.32.7l1.89,1.1a.78.78,0,0,0,.78-.08l9.79-5.65a2.4,2.4,0,0,0,1.09-1.89v-7.35a.77.77,0,0,0-.32-.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "155.285px 354.823px"
    },
    id: "elzvj506zagl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.63,362.11l1.89,1.1a.78.78,0,0,0,.78-.08l7.46-4.3L148.63,353a2.21,2.21,0,0,0-.32,1.08v7.35A.75.75,0,0,0,148.63,362.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "153.534px 358.14px"
    },
    id: "eldqfyuan6jc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,355.15v7.35c0,.7.49,1,1.09.63l9.79-5.65a2.4,2.4,0,0,0,1.09-1.89v-7.35c0-.7-.49-1-1.09-.63l-9.79,5.65A2.41,2.41,0,0,0,150.21,355.15Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "156.195px 355.37px"
    },
    id: "eln965rhm95hr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,352.7l.29-.16s.08,0,.1,0a.17.17,0,0,1,.05.13v.81a.49.49,0,0,1-.05.19.2.2,0,0,1-.1.12l-.4.24-.09.92.35-.2a.08.08,0,0,1,.1,0,.17.17,0,0,1,.05.13v.81a.45.45,0,0,1-.05.19.25.25,0,0,1-.1.12l-.47.28-.07.75a.75.75,0,0,1-.05.16.22.22,0,0,1-.09.1l-.58.33a.05.05,0,0,1-.08,0,.14.14,0,0,1,0-.11h0l.06-.73-.4.23-.08.76a.33.33,0,0,1,0,.15.35.35,0,0,1-.09.11l-.58.33a.05.05,0,0,1-.08,0,.12.12,0,0,1,0-.11h0l.07-.73-.28.16a.08.08,0,0,1-.1,0,.17.17,0,0,1-.05-.13v-.81a.45.45,0,0,1,.05-.19.34.34,0,0,1,.1-.13l.4-.23.09-.92-.35.2a.08.08,0,0,1-.1,0,.18.18,0,0,1-.05-.14v-.8a.41.41,0,0,1,.05-.19.34.34,0,0,1,.1-.13l.47-.27.07-.76a.78.78,0,0,1,.05-.14.24.24,0,0,1,.08-.11l.58-.33s.07,0,.09,0a.18.18,0,0,1,0,.11v0l-.08.72.41-.24.07-.75a.88.88,0,0,1,.05-.15.18.18,0,0,1,.09-.1l.58-.34a.05.05,0,0,1,.08,0,.12.12,0,0,1,0,.11v0Zm-1.44,3,.41-.24.08-.92-.41.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "156.25px 355.105px"
    },
    id: "elzfaez4tqy5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,337.08a.76.76,0,0,0-.77.08l-9.79,5.65a2.4,2.4,0,0,0-1.09,1.89v7.35a.79.79,0,0,0,.31.71l1.9,1.09a.77.77,0,0,0,.78-.07l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35a.76.76,0,0,0-.32-.7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "171.455px 345.468px"
    },
    id: "el0fww4uf7oeqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,352.76l1.9,1.09a.77.77,0,0,0,.78-.07l7.46-4.31-10.13-5.85a2.24,2.24,0,0,0-.32,1.08v7.35A.79.79,0,0,0,164.83,352.76Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "169.743px 348.772px"
    },
    id: "elwgj6p8wu63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.41,345.8v7.35c0,.69.49,1,1.1.63l9.78-5.65a2.42,2.42,0,0,0,1.1-1.9v-7.35c0-.69-.49-1-1.1-.63l-9.78,5.65A2.42,2.42,0,0,0,166.41,345.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "172.4px 346.015px"
    },
    id: "elznfx9h3voe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.82,343.1a.09.09,0,0,1,.11,0,.23.23,0,0,1,0,.14v.89a.58.58,0,0,1,0,.18.25.25,0,0,1-.11.13l-1.64.95v1.15l1.53-.88s.08,0,.1,0a.16.16,0,0,1,.05.13v.89a.41.41,0,0,1-.05.19.27.27,0,0,1-.1.13l-1.53.88v1.82a.39.39,0,0,1,0,.18.28.28,0,0,1-.1.13l-.72.41a.08.08,0,0,1-.1,0,.2.2,0,0,1-.05-.14v-5.44a.41.41,0,0,1,.05-.18.24.24,0,0,1,.1-.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "170.575px 346.759px"
    },
    id: "elhma586upmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,347.54a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.86l-1.73,1a.08.08,0,0,1-.1,0,.16.16,0,0,1,0-.13v-.89a1.11,1.11,0,0,1,.08-.41L174,342a.65.65,0,0,1,.09-.17.31.31,0,0,1,.11-.09l.83-.48a.08.08,0,0,1,.1,0,.16.16,0,0,1,.05.13v3.24l.47-.28a.08.08,0,0,1,.1,0,.18.18,0,0,1,.05.14v.89a.41.41,0,0,1-.05.18.24.24,0,0,1-.1.13l-.47.27v.86a.45.45,0,0,1-.05.19.25.25,0,0,1-.1.12Zm-.12-2.37v-1.55l-.8,2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.103px 344.405px"
    },
    id: "el021k351zl4gi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.16,265.42V403.53c0,14.69-10.32,20.64-23,13.3L69,408.65A8.48,8.48,0,0,1,65.12,402V219.57c0-2.45,1.71-3.44,3.84-2.22l14.16,8.18C95.84,232.87,106.16,250.73,106.16,265.42Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "85.64px 318.401px"
    },
    id: "elybjuy4pi1ip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.41,410.22a12.1,12.1,0,0,1-5.85-2l-12.18-7a2.82,2.82,0,0,1-1.4-2.43V237.11a2.8,2.8,0,0,1,4.2-2.43c10.54,6.09,19.11,19.17,19.11,31.34V402.64c0,2.92-.58,5.33-1.6,6.6A2.57,2.57,0,0,1,93.41,410.22ZM77.53,398.38l11.8,6.81a10.3,10.3,0,0,0,3.79,1.47,10.33,10.33,0,0,0,.62-4V266c0-10.42-7.31-21.74-16.21-27.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.635px 322.269px"
    },
    id: "elagc3g6qdy5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.66,221.28l12.69,7.32c11.72,6.77,21.26,23.29,21.26,36.82V403.53c0,8.08-3.44,12.9-9.2,12.9a17.55,17.55,0,0,1-8.51-2.67l-14.17-8.18A5.06,5.06,0,0,1,68.66,402V221.28m-1.42-4.46c-1.26,0-2.12,1-2.12,2.75V402A8.48,8.48,0,0,0,69,408.65l14.16,8.18A21,21,0,0,0,93.41,420c7.56,0,12.75-6,12.75-16.45V265.42c0-14.69-10.32-32.55-23-39.89L69,217.35a3.47,3.47,0,0,0-1.72-.53Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "85.64px 318.41px"
    },
    id: "elupvj62bf84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6az9xi05wwi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.66,221.28l12.69,7.32c11.72,6.77,21.26,23.29,21.26,36.82V403.53c0,8.08-3.44,12.9-9.2,12.9a17.55,17.55,0,0,1-8.51-2.67l-14.17-8.18A5.06,5.06,0,0,1,68.66,402V221.28m-1.42-4.46c-1.26,0-2.12,1-2.12,2.75V402A8.48,8.48,0,0,0,69,408.65l14.16,8.18A21,21,0,0,0,93.41,420c7.56,0,12.75-6,12.75-16.45V265.42c0-14.69-10.32-32.55-23-39.89L69,217.35a3.47,3.47,0,0,0-1.72-.53Z",
    style: {
      opacity: 0.35,
      transformOrigin: "85.64px 318.41px"
    },
    className: "animable",
    id: "elku427ik0lr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.64,335.29a6.84,6.84,0,0,1-3.44-.89c-2.46-1.42-3.82-4.35-3.82-8.23V236.34c0-7.62,5.37-16.91,12-20.72l34.59-20c3.36-1.94,6.57-2.22,9-.8s3.82,4.34,3.82,8.22v89.84c0,7.61-5.37,16.91-12,20.71l-34.59,20A11.3,11.3,0,0,1,194.64,335.29Zm44.87-139.56a9.54,9.54,0,0,0-4.69,1.46l-34.59,20c-6.1,3.52-11.07,12.13-11.07,19.18v89.83c0,3.22,1,5.6,2.93,6.69s4.46.8,7.25-.81l34.59-20C240,308.56,245,300,245,292.91V203.07c0-3.22-1-5.6-2.93-6.69A5.07,5.07,0,0,0,239.51,195.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "217.085px 264.609px"
    },
    id: "elh4p75r9uged",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,240.51c-3.07,1.78-5.49,6.22-6.84,10.9-.28,1-.1,1.72.36,2h0c.58.36,1.53.17,2-1,1.2-3.26,2.55-6.93,4.56-8.41,2.2-1.63,4.07-1.36,5.13,1.3.33.82,1.2,1,1.78,0h0a2.65,2.65,0,0,0,.16-2.34C223.47,239.84,220.79,238.73,217.71,240.51Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "217.898px 246.617px"
    },
    id: "elc437uhaxotg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.77,233.17c-4.57,2.65-8.6,8.66-10.9,15.53-.34,1-.24,2,.25,2.35h0c.56.36,1.58,0,2-1.09,1.86-5.62,4.93-10.93,8.67-13.1s7-1.05,8.91,2.41c.39.7,1.19.47,1.75-.54h0a3,3,0,0,0,.26-2.63C225.4,231.88,221.36,230.52,216.77,233.17Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "216.785px 241.498px"
    },
    id: "el59a534dm8g6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,230.6a4.37,4.37,0,0,1-.44,1c-.59.95-1.4,1.18-1.8.49a8.64,8.64,0,0,0-5.81-4.46c-6.61-1.23-15.21,6.36-19.45,18.1l-.21.58c-.4,1.14-.94,1.83-1.94,1.49s-.93-1.58-.54-2.72l.24-.67c5-13.75,15.3-22.45,23-21a10.11,10.11,0,0,1,6.81,5.23A2.7,2.7,0,0,1,231.53,230.6Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "216.362px 235.57px"
    },
    id: "elverv0oeda3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,265.31c0,.1,0,.22,0,.38v1a3.44,3.44,0,0,0,0,.36,2.49,2.49,0,0,0,.06.42.66.66,0,0,0,.14.29.4.4,0,0,0,.26.12.86.86,0,0,0,.38-.12,1.61,1.61,0,0,0,.37-.3,1.51,1.51,0,0,0,.24-.34,1.63,1.63,0,0,0,.14-.34c0-.12.06-.22.08-.31a1,1,0,0,1,.07-.27.45.45,0,0,1,.15-.16l.88-.5a.08.08,0,0,1,.1,0s0,.07,0,.13a3.79,3.79,0,0,1-.17,1.08,4.83,4.83,0,0,1-.43,1.05,5.5,5.5,0,0,1-.66.92,3.31,3.31,0,0,1-.81.66,1.73,1.73,0,0,1-.86.28,1,1,0,0,1-.64-.23,1.46,1.46,0,0,1-.41-.65,3.51,3.51,0,0,1-.16-1c0-.28,0-.58,0-.9s0-.63,0-.93a5.54,5.54,0,0,1,.57-2.28,4.53,4.53,0,0,1,.64-1,3.23,3.23,0,0,1,.86-.71,1.92,1.92,0,0,1,.81-.28,1.2,1.2,0,0,1,.66.16,1.16,1.16,0,0,1,.43.55,2.14,2.14,0,0,1,.17.89.39.39,0,0,1,0,.18.32.32,0,0,1-.1.12l-.88.51c-.07,0-.12.05-.15,0a.39.39,0,0,1-.07-.19c0-.07-.05-.14-.08-.22a.37.37,0,0,0-.14-.18.43.43,0,0,0-.24-.06.86.86,0,0,0-.37.13,1.5,1.5,0,0,0-.38.32,1.59,1.59,0,0,0-.26.41,2.24,2.24,0,0,0-.14.46A3.93,3.93,0,0,0,210,265.31Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "210.805px 265.669px"
    },
    id: "elpnc5btdabq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,259.14a.15.15,0,0,1,.2,0,.44.44,0,0,1,.1.16l1.44,5.62a.38.38,0,0,1,0,.32.32.32,0,0,1-.1.12l-.84.49c-.09,0-.15.06-.19,0a.21.21,0,0,1-.07-.13l-.19-.74-1.77,1-.18,1a1.28,1.28,0,0,1-.07.21.44.44,0,0,1-.19.19l-.84.49a.08.08,0,0,1-.1,0,.17.17,0,0,1-.05-.13.75.75,0,0,1,0-.17l1.45-7.29a1.37,1.37,0,0,1,.1-.28.45.45,0,0,1,.2-.23Zm-1.08,5.1,1.08-.63-.54-2.14Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "215.46px 263.495px"
    },
    id: "ela5x1wd74hdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.29,256.66a2.34,2.34,0,0,1,.79-.31.8.8,0,0,1,.58.09.93.93,0,0,1,.38.52,3.13,3.13,0,0,1,.13,1,4.42,4.42,0,0,1-.21,1.4,3.91,3.91,0,0,1-.58,1.11l.82,2a.3.3,0,0,1,0,.1.58.58,0,0,1,0,.18.36.36,0,0,1-.11.13l-.9.52c-.09.05-.15.06-.19,0a.42.42,0,0,1-.09-.14l-.74-1.76-.61.35V264a.64.64,0,0,1,0,.23.33.33,0,0,1-.13.15l-.87.51a.12.12,0,0,1-.13,0,.26.26,0,0,1-.05-.17v-6.61a.68.68,0,0,1,.05-.23.39.39,0,0,1,.13-.15Zm-.75,3.54.75-.44a1.35,1.35,0,0,0,.46-.43,1.16,1.16,0,0,0,.19-.7c0-.29-.06-.45-.19-.49a.63.63,0,0,0-.46.11l-.75.43Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "220.293px 260.62px"
    },
    id: "elu16x1kaeece",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.87,254a1.85,1.85,0,0,1,.84-.28,1,1,0,0,1,.65.21,1.47,1.47,0,0,1,.44.66,3.49,3.49,0,0,1,.17,1c0,.14,0,.27,0,.39v.68c0,.12,0,.24,0,.38a5.88,5.88,0,0,1-.17,1.26,5.15,5.15,0,0,1-.42,1.14,4.72,4.72,0,0,1-.64,1,3.15,3.15,0,0,1-.83.69l-1.8,1a.1.1,0,0,1-.13,0,.23.23,0,0,1,0-.16v-6.62a.59.59,0,0,1,0-.22.36.36,0,0,1,.13-.16Zm.87,2.31q0-1.15-.9-.66l-.68.39V260l.71-.41a1.83,1.83,0,0,0,.87-1.68c0-.14,0-.28,0-.41v-.73C225.75,256.6,225.75,256.47,225.74,256.33Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "224.968px 257.937px"
    },
    id: "el870tko3804y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.28,202.27a7.41,7.41,0,0,0-3.34,5.79c0,2.13,1.5,3,3.34,1.93a7.38,7.38,0,0,0,3.35-5.79C240.63,202.07,239.13,201.2,237.28,202.27Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "237.285px 206.13px"
    },
    id: "elt19uxkwzd8j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63",
    className: "animable animator-active",
    style: {
      transformOrigin: "371.151px 228.68px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-63",
    className: "animable",
    style: {
      transformOrigin: "371.151px 228.68px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-63",
    className: "animable",
    style: {
      transformOrigin: "371.151px 239.988px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-63",
    className: "animable",
    style: {
      transformOrigin: "341.978px 180.224px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.92,162.13c-4.54,10.15-8.34,20.94-11.69,25.33-6.83,4.18-24.1,12.76-30.64,14.38a4.91,4.91,0,0,1-3.41-.41c-2.81-1.41-4.86-1.45-7.71-2.09-2.24-.5-3.27-1.42-3.63-1s-.82,1.8.66,3.13a23.34,23.34,0,0,0,3.65,2.42,20.43,20.43,0,0,1-9,1.18c-5.91-.86-8.31,2.21-3.71,8,1.64,2.07,7.52,5,18.51,2.79a102.07,102.07,0,0,0,11.63-2.74c10.38-3.49,21.95-7,29-10a16.66,16.66,0,0,0,6.5-5.7c7.69-12.86,13.56-22.36,17.89-32l-.65-20.61C371.48,144.34,368.72,153.63,364.92,162.13Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "340px 180.72px"
    },
    id: "el3h0pj2fhz6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,187.19s10.73-27.47,16.09-36.53c3.74-6.32,8.21-6.81,15.93-6.86,5,8.2-1.42,22.21-1.42,22.21s-9,18.44-15.48,29.31c-4.23,7.1-5.55,7.58-11.58,10s-18.76,7.25-18.76,7.25c.59-4.87-1.39-11.92-4.73-14.95Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "359.988px 178.185px"
    },
    id: "el7elgv9c37em",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,387.69c.14,1.31.32,5,7,5.91s10.86-1.29,12.64-4.5,1.37-5.82,1.65-8.79,2.74-4.55,3.45-6.08c1-2.26-.48-5.76-.48-5.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.103px 381.138px"
    },
    id: "el6qljm6jgaqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.91,366.22a4,4,0,0,0,.44,3.22A13.94,13.94,0,0,0,363,372.3a25.77,25.77,0,0,0,11.31-4.43,15,15,0,0,1,8.73-2.52c3.2-.11,5.55-.82,5.79-1.66.43-1.48.43-2.42-.28-2.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.438px 366.881px"
    },
    id: "elonmd79qac2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.26,363.31c-.84,6.08-12.62,5.59-11.66.73l-2.11-14.76,13.34.42Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "416.375px 358.529px"
    },
    id: "el10yzqc5fo73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,384.66A40.63,40.63,0,0,1,404.1,381,33,33,0,0,0,411,363.32c0-.36.07-1.05.42-1.27s.72.09,1.11.26l0,0v0a7.5,7.5,0,0,0,2.06.54c2.37.26,5-.31,5.57-.23s.6,1.49.56,3c.84-.53,1.11-1.58,1.87-2.19.41-.34.59-.35.58-.89,0-.36,0-.68,0-1,.6-.17,1.11,2.15,1.61,3.92.58,2.06,1.29,4.38.48,6.46a17.88,17.88,0,0,1-1.87,3.22A13.37,13.37,0,0,0,421,381c-.09.93,0,1.88-.15,2.81a8.26,8.26,0,0,1-5.81,6.78c-4.07,1.27-10.17,1.07-13.75-1.78C400,387.85,400.45,385.76,401,384.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "413.039px 376.434px"
    },
    id: "el9jjeouvetgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.86,351.26c-3.23,2.51-7.12,4-11.09,2.18l-.93-24.84,13.38,2.4Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "380.53px 341.423px"
    },
    id: "elnd5jprvmlv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.61,361.93c.88-.28,1.76-.6,2.63-.94a49.42,49.42,0,0,0,7-3.49c1-.59,1.95-1.21,2.89-1.87s1.91-1.46,2.85-2.22a10.39,10.39,0,0,0,1.35-1.46,14.86,14.86,0,0,0,2-3.24,1.16,1.16,0,0,1,.5-.66,1,1,0,0,1,.94.19,4.49,4.49,0,0,0,.73.5l.79.32a8.82,8.82,0,0,0,2.63.65c3.38.3,3.49-.38,3.64.71a7.71,7.71,0,0,1,0,1.23c1.79-.3,3.2-.88,3.28-1.56l.21-2.16c1.78-.16,1.9,3,2.49,6.6.47,2.9,1.16,5,.37,7.13-2.7,2.35-7.44,1.78-10.15,2.23-3.83.63-5.62,3.46-10.94,5.3-8.58,3-14-.45-15.6-1.95C351.17,365.34,351,363.09,354.61,361.93Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "370.416px 359.151px"
    },
    id: "elbrd3l2rltnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.49,206.23c.68,10.53,1.92,26,2.35,38.14.81,22.88.49,54.47.49,54.47a79.05,79.05,0,0,1,2.46,14.66c.55,14.61.45,51.1.45,51.1s-6.06,6.1-15.13,1.31c0,0-8-49.68-10.27-64.1-2.15-13.73-6.33-46.73-6.33-46.73l-1.89,32.57S393.83,300.19,393,311c-.49,6.69-4.31,39.75-4.31,39.75-3.48,3.27-13.64,1.49-15.86-1.11,0,0-3.56-53.45-3.95-60.5-.86-15.27-3.12-65.73-2-74.56S419.49,206.23,419.49,206.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.911px 286.985px"
    },
    id: "eldzih4894qmb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.51,255.08l-2.66-17.6s-7.31-1.39-12.65-5.35c0,0,2.08,4.71,10.16,8.06L391,256.58l.63,31.07Z",
    id: "els9kllxsd7cj",
    className: "animable",
    style: {
      transformOrigin: "385.855px 259.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.1,217.75c.74-23,.69-29.21,2.77-45.93s5.36-21.27,9.19-24.11c2.47-1.83,14.32-6.59,14.32-6.59l0,4.2c8.07-.84,17-5.89,17-5.89l3.66.75c8.29,4.23,19.87,8.15,21.29,10.31,0,0-3.65,17.69-6.52,25.86-3,8.55-5.64,28.91-5.64,28.91,4,17.86,4.08,24.18,5,37.9.73,11,.55,27.71.55,27.71s-12.37,5.74-33.21,5.05-29.16-4.72-29.16-4.72S364.39,239.89,365.1,217.75Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "398.84px 207.704px"
    },
    id: "el1uc9aw6vnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.77,172.8s-3.53,9.89-4.87,35.35c-1.09,20.6-.76,53.72-.6,65.62.87.18,1.81.35,2.82.52C375.44,255.38,373.66,193.27,378.77,172.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "375.948px 223.545px"
    },
    id: "eleugirp3f6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.49,
    cy: 194.17,
    r: 1.85,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "380.49px 194.17px"
    },
    id: "elyq3908v23ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.71,
    cy: 194.63,
    r: 1.85,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "390.71px 194.63px"
    },
    id: "elpzwbnqol7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.05,
    cy: 206.71,
    r: 1.85,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "380.05px 206.71px"
    },
    id: "elzuflsuneoug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,207.17a1.85,1.85,0,1,1-1.85-1.85A1.85,1.85,0,0,1,392.13,207.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "390.28px 207.17px"
    },
    id: "ellam3cej7hhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.62,
    cy: 219.25,
    r: 1.85,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "379.62px 219.25px"
    },
    id: "eluvdf9ioqznm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.7,219.71a1.86,1.86,0,1,1-1.85-1.85A1.85,1.85,0,0,1,391.7,219.71Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "389.84px 219.72px"
    },
    id: "elcetcxt333c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,160.26c1.58-3.79-1.6-13.94-5.6-20.83a70,70,0,0,1-6.92-16.22s9.53-1.44,19.83-3.85,32.38-6.14,30.73,0-11,16.83-18.87,22S382.32,160.26,382.32,160.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "395.124px 138.137px"
    },
    id: "elgad2hof1gqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.77,98.55s.24,0,.62.13a2.87,2.87,0,0,1,1.53-3.23,3.09,3.09,0,0,1,4,1.63l-4.34,2a6,6,0,0,1,3.3,2.81c1.19,2.45-.38,7.65-2,14.08a88.33,88.33,0,0,1-3.5,11.91c-.72,1.87-2,1.93-2,1.93v-6.41L406,116.32a46.87,46.87,0,0,1-1.14-6.73c-.48-4.91.55-6.92.55-6.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.826px 112.516px"
    },
    id: "el64ket4hpgba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.18,93a10.82,10.82,0,1,1-10.85,10.78A10.81,10.81,0,0,1,387.18,93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.15px 103.82px"
    },
    id: "eloohapl370xb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63,117c1.28,1.11,2.52-2,3.77-2.9,1.44-1.07,4.75-1.6,5.82,1.7,1.22,3.73-1.58,7.08-3.7,8.13a4.27,4.27,0,0,1-5.15-.54v16c-3.92,2.85-16.38,8.42-20.53,9.44a37.85,37.85,0,0,1,3.54-7.22l0-6.55a19.54,19.54,0,0,1-5.3.28c-3.5-.55-5.37-3.44-6.42-7.23-1.69-6.09-2-16.33.3-28.16,3.93-3,17.19-2.54,25.42,2.68C404.81,113.16,406.34,115.89,407.63,117Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "397.915px 123.462px"
    },
    id: "ellei4osy07g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.41,135.1s7.82-1.55,10.56-3a8.93,8.93,0,0,0,3.79-3.72,12.29,12.29,0,0,1-2.16,4.4c-2,2.55-12.2,4.4-12.2,4.4Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "398.58px 132.78px"
    },
    id: "eltzcbvrsikgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,110.89a3.21,3.21,0,0,0,.72,1.68,1.4,1.4,0,0,1,.28.6,29.77,29.77,0,0,0,1,4.52,5,5,0,0,0,4.78,3.3,6.56,6.56,0,0,0,1.65-.1.5.5,0,0,0,.13,0,4.67,4.67,0,0,0,1.35-.49.2.2,0,0,1,.09-.05l.11-.07.14-.11a.43.43,0,0,0,.13-.09,1,1,0,0,0,.16-.12l.14-.12a3.25,3.25,0,0,0,.27-.26,6.5,6.5,0,0,0,1.11-1.69c.73-1.56.59-3.77,1.74-4l.14,0h.15c1.57.06,1.35,2.45,2.18,4.18a5.86,5.86,0,0,0,5.66,3.55H397l.35,0a6.34,6.34,0,0,0,.82-.1l.26-.06a1.05,1.05,0,0,0,.24-.06l.16,0a5.77,5.77,0,0,0,.93-.41c.1-.08.21-.13.31-.2a6,6,0,0,0,.53-.46,5,5,0,0,0,1.06-1.58,26.75,26.75,0,0,0,1-4.44,1.67,1.67,0,0,1,.27-.65,3.12,3.12,0,0,0,.79-1.59,1.39,1.39,0,0,0-.92-1.44l-.82-.13c-2.68-.37-6.16-.58-8.26-.05-2.64.66-3.57,1.48-5,1.43s-2.22-1-4.7-1.81a22.43,22.43,0,0,0-7.72-.54c-.27,0-.52,0-.78.06C375.06,109.53,374.6,110.17,374.63,110.89Zm17.2,2a2.3,2.3,0,0,1,.75-.59.46.46,0,0,1,.14-.07l.07,0,.38-.17.34-.13a10.82,10.82,0,0,1,1.13-.32,3.27,3.27,0,0,1,.45-.1,11,11,0,0,1,1.15-.16l.27,0c2.52-.15,4.09.48,4.64,1s.27,2.87,0,4c0,0,0,.06,0,.08a.29.29,0,0,1,0,.09c0,.14-.07.31-.12.47s-.05.2-.08.3h0c-.06.17-.12.33-.19.49a.87.87,0,0,1-.07.17.34.34,0,0,1-.05.11.47.47,0,0,1-.05.1l-.07.14-.09.16a1.53,1.53,0,0,1-.11.16l-.1.17a4,4,0,0,1-3.56,1.6,4.93,4.93,0,0,1-3.7-1.5,5.13,5.13,0,0,1-1.17-2.41C391.47,115.13,391.32,113.57,391.83,112.87ZM377,111.35a2.13,2.13,0,0,1,.63-.38.06.06,0,0,1,.05,0l.27-.11.16,0,.14,0a.29.29,0,0,0,.1,0h0l.14,0a3.53,3.53,0,0,1,.58-.08,1.73,1.73,0,0,1,.32,0h1c.37,0,.76.06,1.17.13,1.79.3,3.65,1.17,4.12,1.92s.34,2.27.08,3.59a8.52,8.52,0,0,1-.24.88.09.09,0,0,0,0,.07l0,.09s0,0,0,.06,0,.07,0,.11a2.12,2.12,0,0,0-.11.21c0,.06-.06.11-.09.19a.1.1,0,0,0,0,0l-.08.13a.9.9,0,0,1-.07.11h0a4,4,0,0,1-3.78,1.64,4.48,4.48,0,0,1-1.89-.5c-1.76-.94-2.18-3-2.38-3.88C376.78,114.2,376.48,111.84,377,111.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "389.177px 115.518px"
    },
    id: "eluc3f2eytfhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.61,110.57l11.59,2.72a4.31,4.31,0,0,0-3.43,1.44l-8.17-1.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.4px 112.65px"
    },
    id: "el9mlwaw5kc78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,115.4c.2.93.62,2.94,2.38,3.88a4.48,4.48,0,0,0,1.89.5,4,4,0,0,0,3.78-1.64h0a.9.9,0,0,0,.07-.11l.08-.13a.1.1,0,0,1,0,0c0-.08.07-.13.09-.19a2.12,2.12,0,0,1,.11-.21s0-.08,0-.11,0,0,0-.06l0-.09a.09.09,0,0,1,0-.07,8.52,8.52,0,0,0,.24-.88c.26-1.32.4-2.85-.08-3.59s-2.33-1.62-4.12-1.92c-.41-.07-.8-.1-1.17-.13h-1a1.73,1.73,0,0,0-.32,0,3.53,3.53,0,0,0-.58.08l-.14,0h0a.29.29,0,0,1-.1,0l-.14,0-.16,0-.27.11a.06.06,0,0,0-.05,0,2.13,2.13,0,0,0-.63.38C376.48,111.84,376.78,114.2,377,115.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "381.281px 115.229px"
    },
    id: "elsbft7pc2enm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.76,116.46a5.13,5.13,0,0,0,1.17,2.41,4.93,4.93,0,0,0,3.7,1.5,4,4,0,0,0,3.56-1.6l.1-.17a1.53,1.53,0,0,0,.11-.16l.09-.16.07-.14a.47.47,0,0,0,.05-.1.34.34,0,0,0,.05-.11.87.87,0,0,0,.07-.17c.07-.16.13-.32.19-.49h0c0-.1.06-.2.08-.3s.09-.33.12-.47a.29.29,0,0,0,0-.09s0-.06,0-.08c.26-1.18.58-3.51,0-4s-2.12-1.16-4.64-1l-.27,0a11,11,0,0,0-1.15.16,3.27,3.27,0,0,0-.45.1,10.82,10.82,0,0,0-1.13.32l-.34.13-.38.17-.07,0a.46.46,0,0,0-.14.07,2.3,2.3,0,0,0-.75.59C391.32,113.57,391.47,115.13,391.76,116.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "396.468px 115.846px"
    },
    id: "elm6in894u2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,91.63c0-.14,0-.27.05-.4a1.26,1.26,0,0,1,.26-.68c.53-.55,1.58.83,2,1.15a13.54,13.54,0,0,0,1.12.88,6.77,6.77,0,0,1,1,.63,11.39,11.39,0,0,1,0-3.95c.16-.86.4-2.86,1.47-3.07.64-.13,1.19.4,1.66.84,4.28,4,9.87,2.16,15,2.32,4.31.14,9.52,1.89,11.46,6.09.89,1.92,1.05,3.94-.71,5.26-1.14.86-2.25.82-2.89,2.19-.15.34-1.14,4.42-.56,4.38a4.48,4.48,0,0,1-4.8-3.29c-.11-.44-.35-1.26-.45-1.71a1,1,0,0,0-1.23-.75c-1.31.28-2.16.82-3.4,1.16a24.94,24.94,0,0,1-10.86.64,12.89,12.89,0,0,1-6.82-3.67A10.21,10.21,0,0,1,377.33,91.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.614px 96.7326px"
    },
    id: "el51fxpo3lfrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,108.46l3.78.59a2,2,0,0,0-1.65-2.24A1.86,1.86,0,0,0,394.17,108.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.069px 107.919px"
    },
    id: "elytdhy983i6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.81,108.67l3.84-.42a1.86,1.86,0,0,0-2.06-1.73A2,2,0,0,0,379.81,108.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.727px 107.589px"
    },
    id: "elulkw7zz2wbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.14,113.94l-.51,8.94-5-1.3,5-7.74A1.25,1.25,0,0,1,389.14,113.94Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "386.385px 118.36px"
    },
    id: "elqef3ddtn1pm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391.49,
    cy: 126.21,
    r: 1.49,
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "391.49px 126.21px"
    },
    id: "elrniehw6bqnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.77,172.8c1.42-10,8.6-24.53,12.25-28.52,4.44-4.85,8.71-12.76,9-16.59,0,0,14.78,1.14,20.36-8.33A39.36,39.36,0,0,1,412,140.18s-14.6,5.33-19.95,10.37C384.66,157.53,378.77,172.8,378.77,172.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "399.575px 146.08px"
    },
    id: "eli1dc7avra7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,193.36c-5.68-31.21-3.84-38.71-11.44-43.74a41,41,0,0,0-7.54-3.53c-2.76,3.33-6.43,11-2.28,22.29,0,0,4,17.62,6,26.58-2.45,7.81-6.33,17.17-10,22.21a4.75,4.75,0,0,1-3.14,1.87l-3.9,7a16.86,16.86,0,0,1-1.65,1.54,13.42,13.42,0,0,0,7.92,10.3c1.91-1.44,4.47-3,6.75-5.78a92.32,92.32,0,0,0,6.86-10.87c3.84-6.84,8.1-14,10.59-19.75C444.07,197.2,444.37,195.38,444,193.36Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "427.094px 191.985px"
    },
    id: "el7l6xtl9yee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.79,216.5c0,7,3,18.09,13.52,20.92v3.76s-8-.77-12.31-6.63-5.37-11.4-5.37-18.05Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "414.47px 228.84px"
    },
    id: "elstuqcre58n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.27,222.41c2.84-1.25,4-2.84,7.37-3.37l-3.9,7a14.62,14.62,0,0,1-4,.38,3.29,3.29,0,0,1-3.17-2.61C404.48,223.23,406.05,223.39,408.27,222.41Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "410.103px 222.737px"
    },
    id: "elavw4zdha4x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,145c6.56,1.57,11.33,3.7,13.36,5.33s4.06,10.54,5,16.22,4.06,27,4.16,29.44-12.82,26.73-12.82,26.73-4.87-6.57-12.23-8.78l7.3-19.35-7.71-27.83S415.47,157.76,422.75,145Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "431.898px 183.86px"
    },
    id: "eluq9vcd312la",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exclamation-marks--inject-63",
    className: "animable",
    style: {
      transformOrigin: "356.784px 83.4329px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.51,85a1,1,0,0,1,.08-.75,1,1,0,0,1,.57-.47l4.37-1.32a1,1,0,0,1,1.21.65l1.06,3.5a.92.92,0,0,1-.08.74,1,1,0,0,1-.57.48l-4.37,1.31a1,1,0,0,1-1.21-.65Zm-5.7-18.87a1,1,0,0,1,.65-1.22l4.37-1.32a1,1,0,0,1,.74.08.92.92,0,0,1,.47.57l4.51,14.93a1,1,0,0,1-.65,1.21l-4.36,1.32a.92.92,0,0,1-.74-.08.93.93,0,0,1-.48-.57Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "364.308px 76.3637px"
    },
    id: "el6p02mg7bvxx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,100.63a.9.9,0,0,1-.31-.67,1,1,0,0,1,.24-.71l3.07-3.37a1,1,0,0,1,1.38-.07l2.7,2.46A.91.91,0,0,1,365,99a.94.94,0,0,1-.24.7L361.71,103a1,1,0,0,1-1.38.07ZM343,87.38A1,1,0,0,1,343,86L346,82.63a1,1,0,0,1,1.38-.07L359,93a1,1,0,0,1,.06,1.38L356,97.79a1,1,0,0,1-.68.32,1,1,0,0,1-.7-.25Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "353.863px 92.815px"
    },
    id: "el8gyibnl6nqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el980jzatxut"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "353.863px 92.815px"
    },
    className: "animable",
    id: "elgwohlcb7ail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.63,100.63a.9.9,0,0,1-.31-.67,1,1,0,0,1,.24-.71l3.07-3.37a1,1,0,0,1,1.38-.07l2.7,2.46A.91.91,0,0,1,365,99a.94.94,0,0,1-.24.7L361.71,103a1,1,0,0,1-1.38.07ZM343,87.38A1,1,0,0,1,343,86L346,82.63a1,1,0,0,1,1.38-.07L359,93a1,1,0,0,1,.06,1.38L356,97.79a1,1,0,0,1-.68.32,1,1,0,0,1-.7-.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "353.863px 92.815px"
    },
    id: "el9tpsa4gq9jf",
    className: "animable"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--id-card--inject-63",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "334.763px 295.635px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--id-card--inject-63",
    className: "animable",
    style: {
      transformOrigin: "334.763px 295.635px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.68,237.08,304.19,199.3a2.69,2.69,0,0,0-2.74-.29c-.68.36-3,1.67-4.19,2.4l-.18.1a1.31,1.31,0,0,0-.47.4,2.79,2.79,0,0,0-.36.47.29.29,0,0,1-.08.18c0,.14-.1.33-.13.51a3.58,3.58,0,0,0-.12,1V347.38a8.51,8.51,0,0,0,3.9,6.74L365.32,392a3.4,3.4,0,0,0,1.34.46,2,2,0,0,0,1.26-.13c.07,0,.1,0,.18-.08l4.33-2.5a2.7,2.7,0,0,0,1.15-2.53V243.87A8.66,8.66,0,0,0,369.68,237.08Zm-28.86,6.46-16.63-9.6a9.85,9.85,0,0,1-4.6-7.61c0-2.74,2.06-3.8,4.6-2.31l1.94,1.11,14.69,8.48A9.83,9.83,0,0,1,345,239a6.6,6.6,0,0,1,.43,2.27C345.4,244,343.34,245,340.82,243.54Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "334.758px 295.635px"
    },
    id: "elhupdr7y3hj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgfud6d3324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.68,237.08,304.19,199.3a2.69,2.69,0,0,0-2.74-.29c-.68.36-3,1.67-4.19,2.4l-.18.1a1.31,1.31,0,0,0-.47.4,2.79,2.79,0,0,0-.36.47.29.29,0,0,1-.08.18c0,.14-.1.33-.13.51a3.58,3.58,0,0,0-.12,1V347.38a8.51,8.51,0,0,0,3.9,6.74L365.32,392a3.4,3.4,0,0,0,1.34.46,2,2,0,0,0,1.26-.13c.07,0,.1,0,.18-.08l4.33-2.5a2.7,2.7,0,0,0,1.15-2.53V243.87A8.66,8.66,0,0,0,369.68,237.08Zm-28.86,6.46-16.63-9.6a9.85,9.85,0,0,1-4.6-7.61c0-2.74,2.06-3.8,4.6-2.31l1.94,1.11,14.69,8.48A9.83,9.83,0,0,1,345,239a6.6,6.6,0,0,1,.43,2.27C345.4,244,343.34,245,340.82,243.54Z",
    style: {
      opacity: 0.15,
      transformOrigin: "334.758px 295.635px"
    },
    className: "animable",
    id: "elcrw9sba3fra"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.92,392.27c.07,0,.11,0,.18-.07l4.33-2.5a2.7,2.7,0,0,0,1.16-2.53V243.87a7.82,7.82,0,0,0-1.16-3.86l-4.37,2.5a7.88,7.88,0,0,1,1.16,3.86v143.3A2.64,2.64,0,0,1,367.92,392.27Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "370.763px 316.14px"
    },
    id: "elrenz70fzy4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1x0emeld5vi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.92,392.27c.07,0,.11,0,.18-.07l4.33-2.5a2.7,2.7,0,0,0,1.16-2.53V243.87a7.82,7.82,0,0,0-1.16-3.86l-4.37,2.5a7.88,7.88,0,0,1,1.16,3.86v143.3A2.64,2.64,0,0,1,367.92,392.27Z",
    style: {
      opacity: 0.3,
      transformOrigin: "370.763px 316.14px"
    },
    className: "animable",
    id: "ellq0m1gpehwb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M365.32,239.58,346.88,229l-16.6-9.6-30.46-17.57a2.86,2.86,0,0,0-2.56-.4l-.18.1a1.31,1.31,0,0,0-.47.4,2.79,2.79,0,0,0-.36.47.29.29,0,0,1-.08.18c0,.14-.1.33-.13.51a3.58,3.58,0,0,0-.12,1V347.38a8.51,8.51,0,0,0,3.9,6.74L365.32,392a3.4,3.4,0,0,0,1.34.46,2,2,0,0,0,1.26-.13,2.66,2.66,0,0,0,1.3-2.61V246.37A8.76,8.76,0,0,0,365.32,239.58Zm-24.5,4-16.63-9.6a9.85,9.85,0,0,1-4.6-7.61c0-2.74,2.06-3.8,4.6-2.31l1.94,1.11,14.69,8.48A9.83,9.83,0,0,1,345,239a6.6,6.6,0,0,1,.43,2.27C345.4,244,343.34,245,340.82,243.54Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "332.579px 296.899px"
    },
    id: "elbaxgcecz1l4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87,259.38l-46.6-26.91c-.84-.48-1.51-.09-1.51.87v71.85a3.32,3.32,0,0,0,1.51,2.62l46.6,26.86c.84.48,1.51.09,1.51-.88V262A3.31,3.31,0,0,0,355.87,259.38Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "332.57px 283.57px"
    },
    id: "elsryvm9rxtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31,269.28,322.83,258c.67-2.3,2.05-7.87,3.86-9.54s3.69,3.59,5.88,4.85,4.22-1.51,5.88,1.94C340.26,259,341.64,266.21,342.31,269.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.57px 258.708px"
    },
    id: "elv9qikmru21k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,275.75l-24.08-13.9a2.58,2.58,0,0,1-1.08-2.07v-.93c0-.8.48-1.16,1.08-.82l24.08,13.9a2.61,2.61,0,0,1,1.08,2.08v.92C345.69,275.73,345.21,276.1,344.61,275.75Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.57px 266.892px"
    },
    id: "el536v7uh64xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,276.37,333.11,271l-.54-.31L322.7,265c-.6-.35-1.08,0-1.08.82v1.39a3.89,3.89,0,0,0,1.07,2.24c.57.75,2.67,3.65,4.41,4.81a4,4,0,0,0,2.07.68l2.42-.09a2,2,0,0,1,1,.32h0a3.67,3.67,0,0,1,1,.82l2.41,2.88a5.82,5.82,0,0,0,6.49,2c.58-.08,1.06-.2,1.06-1v-1.39A2.61,2.61,0,0,0,342.44,276.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.585px 273.019px"
    },
    id: "el87z9siinp42",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.05,276c.08,1.48-.69,2.33-1.77,1.92a4.6,4.6,0,0,1-2.33-3.48Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "337.003px 276.231px"
    },
    id: "elrdwgw5v6iz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.09,268.46a5.15,5.15,0,0,0,1.77,4c1.09.84,2.1.49,2.33-.79Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "328.139px 270.688px"
    },
    id: "el7ogwhfyc9uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,297.93l8.35-2.44c-1.89-3.41-9.58-13.74-9.58-13.74-1.27,10.24-6.09,10.07-10,7.78s-8.77-7.66-10-19.37c0,0-7.69,1.44-9.58,2.67l8.35,12.08s-4.29-.86-5.16,1-2.35,24.46-2.35,24.46l18.78,10.85,18.78,10.84s-1.49-24.33-2.35-27.18S343.84,297.93,343.84,297.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.61px 301.11px"
    },
    id: "el584jr3tkysx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.93,336.39l-30.72-17.73c-1.11-.64-2-.12-2,1.17v.81a4.49,4.49,0,0,0,2,3.5l30.71,17.73c1.11.64,2,.12,2-1.17v-.81A4.5,4.5,0,0,0,347.93,336.39Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.565px 330.265px"
    },
    id: "el09vxnzsyxk2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.43,356l-11-6.35c-.46-.27-.84-.08-.84.43a1.83,1.83,0,0,0,.84,1.4l10.95,6.34c.47.27.85.08.85-.42A1.8,1.8,0,0,0,355.43,356Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.91px 353.735px"
    },
    id: "el1gw6r4820s1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,345.07l-26.75-15.44c-.47-.27-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.4l26.75,15.45c.46.27.84.07.84-.43A1.83,1.83,0,0,0,336.47,345.07Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "323.095px 338.264px"
    },
    id: "elfs7j2b3rshm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.43,359.66l-11-6.34c-.46-.27-.84-.08-.84.43a1.83,1.83,0,0,0,.84,1.4l10.95,6.34c.47.27.85.08.85-.43A1.83,1.83,0,0,0,355.43,359.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.91px 357.405px"
    },
    id: "elqs5ow26np5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,348.72l-26.75-15.44c-.47-.27-.84-.08-.84.42a1.79,1.79,0,0,0,.84,1.4l26.75,15.44c.46.27.84.08.84-.42A1.83,1.83,0,0,0,336.47,348.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "323.095px 341.91px"
    },
    id: "ell9fawvwj6g9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.53 365.14 351.53 376.56 348.23 374.66 348.23 363.24 351.53 365.14",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.88px 369.9px"
    },
    id: "elboyqtypd86d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.64 359.43 341.64 370.85 338.34 368.95 338.34 357.53 341.64 359.43",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "339.99px 364.19px"
    },
    id: "el7azq7thnhuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.45 351.81 328.45 363.24 325.15 361.33 325.15 349.91 328.45 351.81",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "326.8px 356.575px"
    },
    id: "ellgodfrqmt5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.91 345.15 316.91 356.58 313.61 354.67 313.61 343.25 316.91 345.15",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "315.26px 349.915px"
    },
    id: "eli1wvfhlarxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.58 362.29 346.58 373.71 344.94 372.76 344.94 361.33 346.58 362.29",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "345.76px 367.52px"
    },
    id: "elgy750p6fxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.5 348.96 323.5 360.38 321.86 359.43 321.86 348.01 323.5 348.96",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "322.68px 354.195px"
    },
    id: "elalukwezfwev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.4 354.67 333.4 366.09 331.75 365.14 331.75 353.72 333.4 354.67",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "332.575px 359.905px"
    },
    id: "elig5h5c0udw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.29 360.38 343.29 371.8 342.46 371.33 342.46 359.91 343.29 360.38",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "342.875px 365.855px"
    },
    id: "elynoy1bme7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.62 353.07 330.62 364.49 329.8 364.02 329.8 352.6 330.62 353.07",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "330.21px 358.545px"
    },
    id: "el60khu8tr5cy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.87 356.1 335.87 367.52 335.04 367.05 335.04 355.63 335.87 356.1",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "335.455px 361.575px"
    },
    id: "elec6guxk4po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.38 346.58 319.38 358 318.56 357.53 318.56 346.11 319.38 346.58",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "318.97px 352.055px"
    },
    id: "elbopyf07zdho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.52 357.04 337.52 368.46 336.69 367.99 336.69 356.57 337.52 357.04",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "337.105px 362.515px"
    },
    id: "elgwjgtpw3n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.03 347.54 321.03 358.96 320.21 358.49 320.21 347.06 321.03 347.54",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "320.62px 353.01px"
    },
    id: "elcv33ldnwo1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7u41dyj6v7u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,343.94,319.2,328.5c-.47-.27-.85-.08-.85.43a1.78,1.78,0,0,0,.85,1.39L346,345.77c.46.27.84.08.84-.43A1.83,1.83,0,0,0,346,343.94Z",
    style: {
      opacity: 0.3,
      transformOrigin: "332.595px 337.135px"
    },
    className: "animable",
    id: "eloqpegfujis"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,242.15c-.42,2-2.27,2.66-4.49,1.39l-16.63-9.6a9.85,9.85,0,0,1-4.6-7.61c0-2.33,1.48-3.45,3.48-2.81a4.45,4.45,0,0,0-.09.93,9.9,9.9,0,0,0,4.59,7.62l16.64,9.59A5.24,5.24,0,0,0,345.31,242.15Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "332.45px 233.766px"
    },
    id: "eln6qtxdrkd7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljbqczppnypm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.31,242.15c-.42,2-2.27,2.66-4.49,1.39l-16.63-9.6a9.85,9.85,0,0,1-4.6-7.61c0-2.33,1.48-3.45,3.48-2.81a4.45,4.45,0,0,0-.09.93,9.9,9.9,0,0,0,4.59,7.62l16.64,9.59A5.24,5.24,0,0,0,345.31,242.15Z",
    style: {
      opacity: 0.15,
      transformOrigin: "332.45px 233.766px"
    },
    className: "animable",
    id: "elzbp8uczu75c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-401--inject-63",
    className: "animable",
    style: {
      transformOrigin: "138.859px 114.602px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-63",
    className: "animable",
    style: {
      transformOrigin: "138.859px 114.602px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103,131.14a.76.76,0,0,1-1-.07,1.74,1.74,0,0,1-.41-1.28v-8.11l-16.28,9.4a.75.75,0,0,1-1-.07,1.7,1.7,0,0,1-.41-1.28V121.3a10.45,10.45,0,0,1,.67-3.81l15.45-38.91a7.59,7.59,0,0,1,.85-1.65A3.66,3.66,0,0,1,102,76l7.8-4.5a.75.75,0,0,1,1,.07,1.71,1.71,0,0,1,.41,1.27v30.55l4.44-2.57a.75.75,0,0,1,1,.07,1.7,1.7,0,0,1,.42,1.28v8.43a4,4,0,0,1-.42,1.75,2.54,2.54,0,0,1-1,1.2l-4.44,2.57v8.11a4.11,4.11,0,0,1-.41,1.75,2.64,2.64,0,0,1-1,1.21Zm-1.13-22.34V94.16l-7.55,19Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "100.485px 101.318px"
    },
    id: "eloy33oi47lyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.43,55.35q3.87-2.24,6.66-2.1a6.71,6.71,0,0,1,4.63,2,11.81,11.81,0,0,1,2.73,5.3,34.26,34.26,0,0,1,1.06,7.63c.07,2.24.11,4.6.11,7.1s0,4.84-.11,7.06a52.89,52.89,0,0,1-1.06,8.84,38.65,38.65,0,0,1-2.73,8.47,33.44,33.44,0,0,1-4.63,7.36,24.52,24.52,0,0,1-6.66,5.6q-3.88,2.24-6.67,2.1a6.68,6.68,0,0,1-4.63-2,11.7,11.7,0,0,1-2.73-5.3,34.17,34.17,0,0,1-1.06-7.62c-.07-2.13-.11-4.45-.11-6.94s0-4.9.11-7.22a53.13,53.13,0,0,1,1.06-8.85,38.74,38.74,0,0,1,2.73-8.46A33.21,33.21,0,0,1,129.76,61,24.42,24.42,0,0,1,136.43,55.35ZM142,87.48q.21-6.89,0-13.37a24.75,24.75,0,0,0-.38-3.43,5.89,5.89,0,0,0-.91-2.38,2.24,2.24,0,0,0-1.65-1,4.4,4.4,0,0,0-2.58.78,8.83,8.83,0,0,0-2.59,2.2,11.29,11.29,0,0,0-1.65,2.91,16.53,16.53,0,0,0-.93,3.44,26.48,26.48,0,0,0-.36,3.87q-.27,6.75,0,13.36a21.42,21.42,0,0,0,.33,3.47,5.76,5.76,0,0,0,.93,2.37,2.38,2.38,0,0,0,1.68,1,4.52,4.52,0,0,0,2.59-.78A9,9,0,0,0,139,97.69a11.52,11.52,0,0,0,1.68-2.92,15.53,15.53,0,0,0,.93-3.44A29.35,29.35,0,0,0,142,87.48Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "136.425px 83.98px"
    },
    id: "el9euy0lma75v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29,63.15a2,2,0,0,1-.26-1.44A4.61,4.61,0,0,1,155.6,60l11.11-19.54c.27-.48.61-1,1-1.7a4.07,4.07,0,0,1,1.37-1.42l6.31-3.64a.74.74,0,0,1,1,.07,1.71,1.71,0,0,1,.41,1.27v51.4a4.18,4.18,0,0,1-.41,1.75,2.65,2.65,0,0,1-1,1.2l-6.77,3.91a.75.75,0,0,1-1-.07,1.7,1.7,0,0,1-.42-1.28V57.14l-6.15,10.71a2.12,2.12,0,0,1-1,1,.73.73,0,0,1-.93-.3Z",
    style: {
      fill: "#ECEFF1",
      transformOrigin: "165.899px 63.4983px"
    },
    id: "eliln9qg90co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,188.42a.24.24,0,0,1,.31,0,.51.51,0,0,1,.13.4v1.76a1.19,1.19,0,0,1-.13.54.82.82,0,0,1-.31.38L47,195.61a.24.24,0,0,1-.31,0,.5.5,0,0,1-.13-.39v-16a1.19,1.19,0,0,1,.13-.54.82.82,0,0,1,.31-.38l6.95-4a.23.23,0,0,1,.3,0,.54.54,0,0,1,.13.4v1.76a1.23,1.23,0,0,1-.13.55.83.83,0,0,1-.3.37l-5.21,3v3.94l4.85-2.8a.24.24,0,0,1,.31,0,.54.54,0,0,1,.13.39v1.76a1.34,1.34,0,0,1-.13.55.87.87,0,0,1-.31.38l-4.85,2.8v4.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "50.5003px 184.956px"
    },
    id: "elv2ton0gsfqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.05,170.09c1.35-.78,2.37-.89,3.07-.33s1,1.69,1,3.39a10.49,10.49,0,0,1-.54,3.4A8.49,8.49,0,0,1,63,179.37l2.22,4.84a.74.74,0,0,1,0,.25,1,1,0,0,1-.11.44.62.62,0,0,1-.25.31l-1.37.79c-.21.12-.37.14-.47,0a.89.89,0,0,1-.22-.31l-2.11-4.56-2.14,1.23v5.79a1.34,1.34,0,0,1-.13.54.82.82,0,0,1-.31.38l-1.31.75a.23.23,0,0,1-.3,0,.51.51,0,0,1-.13-.4v-16a1.26,1.26,0,0,1,.13-.55.83.83,0,0,1,.3-.37Zm-2.41,9.21L61,178a4.42,4.42,0,0,0,1.47-1.34,3.85,3.85,0,0,0,.55-2.2c0-.93-.18-1.44-.55-1.55a2,2,0,0,0-1.47.38l-2.33,1.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "60.7988px 179.642px"
    },
    id: "elyyvdnksnges",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.85,163.85c1.35-.77,2.37-.88,3.07-.33s1,1.69,1,3.39a10.55,10.55,0,0,1-.54,3.41,8.18,8.18,0,0,1-1.58,2.81L76.06,178a.69.69,0,0,1,0,.24,1.22,1.22,0,0,1-.1.45.65.65,0,0,1-.25.3l-1.38.8c-.21.12-.37.13-.47,0a.89.89,0,0,1-.22-.31l-2.11-4.56-2.14,1.24V182a1.38,1.38,0,0,1-.13.55.79.79,0,0,1-.31.37l-1.31.76a.23.23,0,0,1-.3,0,.54.54,0,0,1-.13-.4v-16a1.19,1.19,0,0,1,.13-.54.94.94,0,0,1,.3-.38Zm-2.41,9.22,2.33-1.35a4.36,4.36,0,0,0,1.47-1.35,3.83,3.83,0,0,0,.55-2.2c0-.93-.18-1.44-.55-1.54a2,2,0,0,0-1.47.37l-2.33,1.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "71.6393px 173.456px"
    },
    id: "elt28cw2kjupl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.67,167a16.72,16.72,0,0,1,.35-2.82,12.22,12.22,0,0,1,.88-2.64,10.38,10.38,0,0,1,1.45-2.28,7.77,7.77,0,0,1,2.06-1.72,4,4,0,0,1,2-.66,2,2,0,0,1,1.45.6,3.81,3.81,0,0,1,.89,1.62,9.92,9.92,0,0,1,.35,2.43c0,.31,0,.65,0,1s0,.76,0,1.17,0,.8,0,1.18,0,.74,0,1.06a15.85,15.85,0,0,1-.34,2.82,12.22,12.22,0,0,1-.88,2.64,10,10,0,0,1-1.46,2.27,8.1,8.1,0,0,1-2.06,1.71,4.11,4.11,0,0,1-2.06.67,2,2,0,0,1-1.45-.59,3.57,3.57,0,0,1-.88-1.63,10.58,10.58,0,0,1-.35-2.42c0-.31,0-.65,0-1s0-.77,0-1.17,0-.8,0-1.18S77.66,167.29,77.67,167ZM85,162.88a3.26,3.26,0,0,0-.75-2.34c-.46-.39-1.06-.37-1.82.07a4.64,4.64,0,0,0-1.81,2,7.62,7.62,0,0,0-.75,3.2c0,.64,0,1.34,0,2.11s0,1.47,0,2.08a3.1,3.1,0,0,0,.75,2.32c.46.39,1.06.36,1.81-.08a4.59,4.59,0,0,0,1.82-2,7.84,7.84,0,0,0,.75-3.19c0-.64,0-1.34,0-2.11S85,163.49,85,162.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "82.36px 166.465px"
    },
    id: "elk4azhco1erh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.88,151.14q2-1.17,3.06-.33c.7.55,1,1.69,1,3.39a10.49,10.49,0,0,1-.54,3.4,8.51,8.51,0,0,1-1.59,2.82l2.22,4.84a.56.56,0,0,1,0,.25,1,1,0,0,1-.1.44.74.74,0,0,1-.25.31l-1.37.79c-.22.12-.38.14-.48,0a1,1,0,0,1-.22-.31l-2.11-4.56-2.14,1.23v5.79a1.19,1.19,0,0,1-.13.54.82.82,0,0,1-.31.38l-1.3.75a.24.24,0,0,1-.31,0,.51.51,0,0,1-.13-.4v-16a1.26,1.26,0,0,1,.13-.55.84.84,0,0,1,.31-.37Zm-2.42,9.21L93.8,159a4.29,4.29,0,0,0,1.46-1.34,3.85,3.85,0,0,0,.55-2.2c0-.93-.18-1.44-.55-1.55a2,2,0,0,0-1.46.38l-2.34,1.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "93.6105px 160.693px"
    },
    id: "el4bu79oc0z05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,162.25a2.66,2.66,0,0,1,.2-.77,1.23,1.23,0,0,1,.49-.6l1.4-.8a.19.19,0,0,1,.25,0,.45.45,0,0,1,.11.33,1.1,1.1,0,0,1,0,.18l-1.06,4.73a5,5,0,0,1-.22.65,1.12,1.12,0,0,1-.48.55l-.72.42a.19.19,0,0,1-.25,0,.43.43,0,0,1-.11-.32v-.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "100.891px 163.51px"
    },
    id: "elyjk30t0hf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,137.92a.23.23,0,0,1,.3,0,.54.54,0,0,1,.13.4v10.18a14.1,14.1,0,0,1-.29,2.94,11.36,11.36,0,0,1-.87,2.64,9.55,9.55,0,0,1-1.45,2.22,8.16,8.16,0,0,1-2,1.64,4.36,4.36,0,0,1-2,.69,1.93,1.93,0,0,1-1.44-.55,3.37,3.37,0,0,1-.86-1.63,10.4,10.4,0,0,1-.28-2.62V143.67a1.32,1.32,0,0,1,.12-.54.87.87,0,0,1,.31-.38l1.31-.75a.23.23,0,0,1,.3,0,.51.51,0,0,1,.13.4v10.05a6,6,0,0,0,.18,1.63,1.76,1.76,0,0,0,.5.89,1,1,0,0,0,.77.23,2.5,2.5,0,0,0,1-.36,4.47,4.47,0,0,0,1-.78,4.85,4.85,0,0,0,.78-1.12,6.93,6.93,0,0,0,.51-1.48,8.63,8.63,0,0,0,.18-1.84v-10a1.38,1.38,0,0,1,.13-.55.79.79,0,0,1,.31-.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.605px 148.248px"
    },
    id: "ely9bge8va14k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,149.41c-.19.11-.33.11-.42,0a1.9,1.9,0,0,1-.21-.22l-4.52-7.72v10.22a1.23,1.23,0,0,1-.13.55.72.72,0,0,1-.3.37l-1.31.76a.24.24,0,0,1-.3,0,.54.54,0,0,1-.13-.4v-16a1.19,1.19,0,0,1,.13-.54.8.8,0,0,1,.3-.38l1.13-.65c.18-.1.32-.11.42,0a1.32,1.32,0,0,1,.21.23l4.51,7.72V133.06a1.34,1.34,0,0,1,.13-.54.82.82,0,0,1,.31-.38l1.3-.75a.24.24,0,0,1,.31,0,.51.51,0,0,1,.13.4v16a1.26,1.26,0,0,1-.13.55.78.78,0,0,1-.31.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "124.121px 142.378px"
    },
    id: "elvyyuky3n63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.34,126.62c.17-.1.3-.1.38,0a1.11,1.11,0,0,1,.23.5l4,13.41a.7.7,0,0,1,0,.16,1.34,1.34,0,0,1-.13.55.79.79,0,0,1-.31.37l-1.16.67c-.21.13-.37.14-.45,0a.67.67,0,0,1-.18-.3l-.69-2.36-5.1,2.94-.69,3.16a2.25,2.25,0,0,1-.18.51,1,1,0,0,1-.45.47l-1.16.67a.23.23,0,0,1-.3,0,.51.51,0,0,1-.13-.4,1.09,1.09,0,0,1,0-.18l3.95-18a3.87,3.87,0,0,1,.23-.76.86.86,0,0,1,.39-.43Zm.88,10.39-1.77-6-1.77,8.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "135.485px 136.985px"
    },
    id: "elj7apeor1ek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,118.24a.23.23,0,0,1,.31,0,.5.5,0,0,1,.13.39v10.18a14.83,14.83,0,0,1-.29,2.95,11.36,11.36,0,0,1-.87,2.64,9.7,9.7,0,0,1-1.45,2.21,7.86,7.86,0,0,1-2,1.65,4.41,4.41,0,0,1-2,.68,1.93,1.93,0,0,1-1.44-.54,3.41,3.41,0,0,1-.87-1.64,10.89,10.89,0,0,1-.28-2.62V124a1.2,1.2,0,0,1,.13-.55.79.79,0,0,1,.31-.37l1.3-.76a.24.24,0,0,1,.31,0,.54.54,0,0,1,.13.4v10a6,6,0,0,0,.18,1.64,1.69,1.69,0,0,0,.5.89,1,1,0,0,0,.77.22,2.41,2.41,0,0,0,1-.36,4.05,4.05,0,0,0,1-.78,4.6,4.6,0,0,0,.79-1.12,6.5,6.5,0,0,0,.5-1.47,8.09,8.09,0,0,0,.19-1.85v-10a1.26,1.26,0,0,1,.13-.55.83.83,0,0,1,.3-.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "146.701px 128.561px"
    },
    id: "ellotf4qpdhyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.25,112.24a.23.23,0,0,1,.3,0,.54.54,0,0,1,.13.4v1.76a1.23,1.23,0,0,1-.13.55.77.77,0,0,1-.3.37L158.34,117v13.6a1.37,1.37,0,0,1-.12.55.84.84,0,0,1-.31.37l-1.31.76a.23.23,0,0,1-.3,0,.5.5,0,0,1-.13-.39v-13.6l-2.9,1.67a.24.24,0,0,1-.31,0,.52.52,0,0,1-.13-.4v-1.76a1.26,1.26,0,0,1,.13-.55.84.84,0,0,1,.31-.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "157.255px 122.26px"
    },
    id: "eltchsnqi19d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.08,106a.23.23,0,0,1,.3,0,.51.51,0,0,1,.13.4v16a1.26,1.26,0,0,1-.13.55.77.77,0,0,1-.3.37l-1.31.76a.23.23,0,0,1-.3,0,.5.5,0,0,1-.13-.39v-6.56L165.47,120v6.56a1.19,1.19,0,0,1-.13.54.82.82,0,0,1-.31.38l-1.3.75a.24.24,0,0,1-.31,0,.54.54,0,0,1-.13-.41v-16a1.42,1.42,0,0,1,.13-.55.84.84,0,0,1,.31-.37l1.3-.76a.24.24,0,0,1,.31,0,.5.5,0,0,1,.13.39v6.38l4.87-2.81v-6.38a1.19,1.19,0,0,1,.13-.54.75.75,0,0,1,.3-.38Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "167.9px 117.116px"
    },
    id: "el7nsdtpr9px7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.64,111a15.76,15.76,0,0,1,.35-2.81,11.87,11.87,0,0,1,.88-2.64,10,10,0,0,1,1.45-2.28,7.81,7.81,0,0,1,2.06-1.73,4.15,4.15,0,0,1,2.05-.66,2,2,0,0,1,1.45.6,3.79,3.79,0,0,1,.89,1.63,9.91,9.91,0,0,1,.35,2.42c0,.31,0,.65,0,1v2.36c0,.38,0,.74,0,1.06a15.76,15.76,0,0,1-.35,2.81,12.11,12.11,0,0,1-.87,2.65,10.29,10.29,0,0,1-1.46,2.26,7.71,7.71,0,0,1-2.06,1.71,4,4,0,0,1-2.06.67,2,2,0,0,1-1.45-.59,3.58,3.58,0,0,1-.88-1.62,10.13,10.13,0,0,1-.35-2.42c0-.31,0-.65,0-1s0-.77,0-1.18,0-.79,0-1.18S174.63,111.31,174.64,111Zm7.3-4.09a3.21,3.21,0,0,0-.74-2.33,1.5,1.5,0,0,0-1.82.06,4.69,4.69,0,0,0-1.81,2,7.65,7.65,0,0,0-.75,3.2c0,.64,0,1.35,0,2.12s0,1.46,0,2.08a3.12,3.12,0,0,0,.75,2.32c.45.38,1.06.35,1.81-.08a4.71,4.71,0,0,0,1.82-2,7.72,7.72,0,0,0,.74-3.19c0-.64,0-1.35,0-2.12S182,107.51,181.94,106.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "179.378px 110.465px"
    },
    id: "el0jxc3smzc9w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,95.15c1.35-.77,2.37-.88,3.07-.32s1,1.68,1,3.39a10.53,10.53,0,0,1-.54,3.4,8.35,8.35,0,0,1-1.58,2.81l2.22,4.85a.69.69,0,0,1,0,.24,1.06,1.06,0,0,1-.11.45.59.59,0,0,1-.25.3l-1.37.8c-.21.12-.37.13-.47,0a1,1,0,0,1-.22-.31l-2.11-4.57-2.14,1.24v5.78a1.34,1.34,0,0,1-.13.55.79.79,0,0,1-.31.37l-1.31.76a.23.23,0,0,1-.3,0,.54.54,0,0,1-.13-.4v-16a1.2,1.2,0,0,1,.13-.55.77.77,0,0,1,.3-.37Zm-2.41,9.22,2.33-1.35a4.35,4.35,0,0,0,1.47-1.35,3.83,3.83,0,0,0,.55-2.2c0-.92-.18-1.44-.55-1.54a2,2,0,0,0-1.47.37l-2.33,1.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "190.589px 104.712px"
    },
    id: "el8vu5bnp9co7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,108.69a.24.24,0,0,1-.31,0,.51.51,0,0,1-.13-.4v-16a1.26,1.26,0,0,1,.13-.55.84.84,0,0,1,.31-.37l1.3-.76a.24.24,0,0,1,.31,0,.54.54,0,0,1,.13.39v16a1.34,1.34,0,0,1-.13.54.82.82,0,0,1-.31.38Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.139px 99.65px"
    },
    id: "elvv3hbfhl0fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.64,98.57a.23.23,0,0,1,.31,0,.54.54,0,0,1,.13.39v1.76a1.34,1.34,0,0,1-.13.55.79.79,0,0,1-.31.37l-8.08,4.67a.23.23,0,0,1-.3,0,.54.54,0,0,1-.13-.4v-1.76a1.8,1.8,0,0,1,.09-.6l.15-.41,5.72-14.28L201.73,92a.24.24,0,0,1-.31,0,.5.5,0,0,1-.13-.39V89.79a1.19,1.19,0,0,1,.13-.54.76.76,0,0,1,.31-.38l7.75-4.48a.24.24,0,0,1,.31,0,.58.58,0,0,1,.12.4v1.77a2.33,2.33,0,0,1-.2.94L204,101.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "205.605px 95.3494px"
    },
    id: "el9t9si8tquxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.49,92.89a.24.24,0,0,1,.31,0,.54.54,0,0,1,.13.39v1.77a1.34,1.34,0,0,1-.13.54.82.82,0,0,1-.31.38l-7.08,4.08a.23.23,0,0,1-.3,0,.5.5,0,0,1-.13-.39v-16a1.26,1.26,0,0,1,.13-.55.83.83,0,0,1,.3-.37l7-4a.24.24,0,0,1,.31,0,.56.56,0,0,1,.13.4v1.76a1.42,1.42,0,0,1-.13.55.84.84,0,0,1-.31.37l-5.21,3v3.94l4.86-2.8a.23.23,0,0,1,.3,0,.54.54,0,0,1,.13.4v1.76a1.2,1.2,0,0,1-.13.55.8.8,0,0,1-.3.38l-4.86,2.8V96Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "215.954px 89.3944px"
    },
    id: "eltbpo24v18cs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,74.66a4.51,4.51,0,0,1,2.07-.71,2,2,0,0,1,1.47.53,3.56,3.56,0,0,1,.9,1.64,10.94,10.94,0,0,1,.38,2.61c0,1.2,0,2.42,0,3.67a17.42,17.42,0,0,1-.38,3,12.88,12.88,0,0,1-.89,2.67,9.56,9.56,0,0,1-1.44,2.21,8,8,0,0,1-2,1.66l-4.06,2.34a.24.24,0,0,1-.31,0,.56.56,0,0,1-.13-.4v-16a1.42,1.42,0,0,1,.13-.55.84.84,0,0,1,.31-.37ZM229,80a5.42,5.42,0,0,0-.2-1.36,1.86,1.86,0,0,0-.5-.9,1.15,1.15,0,0,0-.83-.32,2.59,2.59,0,0,0-1.19.41l-2.16,1.25V90.22l2.24-1.29a4.39,4.39,0,0,0,1.15-1,5.37,5.37,0,0,0,.8-1.24,6.43,6.43,0,0,0,.49-1.48,8.65,8.65,0,0,0,.2-1.6C229,82.41,229,81.18,229,80Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "226.554px 84.1418px"
    },
    id: "ellcz419jtlik",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg401ErrorUnauthorizedAnimate);
export default __webpack_public_path__ + "static/media/401-error-unauthorized-animate.7ee1393839cd9e7025428886b20f240e.svg";
export { ForwardRef as ReactComponent };